
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire37b7"];
var parcelRegister = parcelRequire.register;
parcelRegister("5WSiB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $436e088c5d0f54a3$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $7Y1tj = parcelRequire("7Y1tj");

var $6eNI5 = parcelRequire("6eNI5");

var $fALlm = parcelRequire("fALlm");

var $4HGiq = parcelRequire("4HGiq");

var $7452z = parcelRequire("7452z");
parcelRequire("h6aRF");
var $ceIrb = parcelRequire("ceIrb");

var $2kfyN = parcelRequire("2kfyN");

const $436e088c5d0f54a3$var$BasePage = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("hmaSN")));
const $436e088c5d0f54a3$var$LoginPage = ()=>{
    (0, $7Y1tj.useLoginPageViewed)();
    const shouldOrchestrate = (0, $ceIrb.useShouldOrchestrate)();
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6eNI5.LoginTooManyAttemptsRecaptchaContextProvider), {
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $fALlm.LoginRecoveryOptionsContextProvider), {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4HGiq.LoginGoogleOneTapRenderBoundary), {
                children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $7452z.MarketingConsentContextProvider), {
                    children: shouldOrchestrate ? /*#__PURE__*/ (0, $4ZSso.jsx)((0, $2kfyN.default), {}) : /*#__PURE__*/ (0, $4ZSso.jsx)($436e088c5d0f54a3$var$BasePage, {})
                })
            })
        })
    });
};
var $436e088c5d0f54a3$export$2e2bcd8739ae039 = $436e088c5d0f54a3$var$LoginPage;

});
parcelRegister("7Y1tj", function(module, exports) {

$parcel$export(module.exports, "useLoginPageViewed", function () { return $399b66e3175a5391$export$6d3326ed5d8fb40e; });

var $6d87w = parcelRequire("6d87w");

var $1V2cH = parcelRequire("1V2cH");

var $ccxRw = parcelRequire("ccxRw");

var $1UkGo = parcelRequire("1UkGo");

var $NAfW5 = parcelRequire("NAfW5");
const $399b66e3175a5391$export$6d3326ed5d8fb40e = ()=>{
    const location = (0, $6d87w.useLocation)();
    // Check which social login options are being shown
    const isMicrosoftButtonEnabled = (0, $ccxRw.isMicrosoftAuthEnabled)(location);
    const isAppleButtonEnabled = (0, $ccxRw.isAppleAuthEnabled)(location);
    const isSlackButtonEnabled = (0, $ccxRw.isSlackAuthEnabled)(location);
    const queryParams = new URLSearchParams(location.search);
    const appendReasonViewingScreen = (0, $NAfW5.useAppendReasonViewingScreen)();
    (0, $1V2cH.usePageViewedEvent)((0, $1UkGo.pageId), {
        ...(0, $1V2cH.appendReferer)(appendReasonViewingScreen({
            isMicrosoftButtonEnabled: isMicrosoftButtonEnabled,
            isAppleButtonEnabled: isAppleButtonEnabled,
            isSlackButtonEnabled: isSlackButtonEnabled
        })),
        noAccess: !!queryParams.get("tenant")
    });
    (0, $1V2cH.useOperationalEvent)({
        page: (0, $1UkGo.pageId),
        action: "loadLoginPageSuccessful",
        subject: "sli"
    });
};

});
parcelRegister("1UkGo", function(module, exports) {

$parcel$export(module.exports, "pageId", function () { return $6b438f71b5f4e8ce$export$703ba2e7ea526c1b; });
const $6b438f71b5f4e8ce$export$703ba2e7ea526c1b = "loginScreen";

});

parcelRegister("NAfW5", function(module, exports) {

$parcel$export(module.exports, "useLoginRecoveryOptions", function () { return $61d6ffcd69039b26$export$7355ce4dcfe6714; });
$parcel$export(module.exports, "useCobrandingApplication", function () { return $61d6ffcd69039b26$export$1d0a4295a0540e3; });
$parcel$export(module.exports, "useSearchParamCodes", function () { return $61d6ffcd69039b26$export$e66bdd3af3ee2b13; });
$parcel$export(module.exports, "useEmailFromSearchParams", function () { return $61d6ffcd69039b26$export$79b4d72483651c8e; });
$parcel$export(module.exports, "useAppendReasonViewingScreen", function () { return $61d6ffcd69039b26$export$833646c3f87e042d; });

var $91i6m = parcelRequire("91i6m");

var $l2v8Y = parcelRequire("l2v8Y");

var $fYxRW = parcelRequire("fYxRW");

var $jy3ZD = parcelRequire("jy3ZD");

var $4rBM8 = parcelRequire("4rBM8");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");
const $61d6ffcd69039b26$export$7355ce4dcfe6714 = ()=>{
    const { state: state } = (0, $4rBM8.useLoginState)();
    const { login: login } = state || {};
    const loginRecoveryOptions = (0, $91i6m.useCallback)((email)=>{
        return (login === null || login === void 0 ? void 0 : login.recoveryToken) && email ? {
            expectedEmail: email,
            recoveryToken: login.recoveryToken
        } : undefined;
    }, [
        login === null || login === void 0 ? void 0 : login.recoveryToken
    ]);
    return loginRecoveryOptions;
};
const $61d6ffcd69039b26$export$1d0a4295a0540e3 = ()=>{
    const { state: state } = (0, $4rBM8.useLoginState)();
    const { cobranding: cobranding } = state || {};
    const applicationData = (0, $91i6m.useMemo)(()=>{
        if (cobranding === undefined) return null;
        return (0, $fYxRW.lookupApplication)(cobranding);
    }, [
        cobranding
    ]);
    return applicationData === null || applicationData === void 0 ? void 0 : applicationData.application;
};
const $61d6ffcd69039b26$export$e66bdd3af3ee2b13 = ()=>{
    const location = (0, $l2v8Y.useLocation)();
    const queryParams = Object.fromEntries(new URLSearchParams(location.search).entries());
    const infoCode = (0, $91i6m.useMemo)(()=>queryParams.infoCode ? {
            code: queryParams.infoCode
        } : null, [
        queryParams.infoCode
    ]);
    const errorCode = (0, $91i6m.useMemo)(()=>queryParams.errorCode ? {
            code: queryParams.errorCode
        } : null, [
        queryParams.errorCode
    ]);
    return {
        errorCode: errorCode,
        infoCode: infoCode
    };
};
const $61d6ffcd69039b26$export$79b4d72483651c8e = ()=>{
    (0, $4PGUW.useRegisterComponent)($61d6ffcd69039b26$export$79b4d72483651c8e.name);
    const location = (0, $l2v8Y.useLocation)();
    const loginHint = (0, $jy3ZD.useLoginHint)();
    const queryParams = Object.fromEntries(new URLSearchParams(location.search).entries());
    return (0, $jy3ZD.getEmailFromLoginHint)(loginHint) || (queryParams === null || queryParams === void 0 ? void 0 : queryParams.email);
};
const $61d6ffcd69039b26$export$833646c3f87e042d = ()=>{
    const { search: search } = (0, $l2v8Y.useLocation)();
    const infoCode = (0, $91i6m.useMemo)(()=>{
        const queryParams = new URLSearchParams(search);
        return queryParams.has("infoCode") ? {
            code: queryParams.get("infoCode")
        } : null;
    }, [
        search
    ]);
    const appendReasonViewingScreen = (0, $91i6m.useCallback)((eventAttributes)=>{
        if (infoCode) switch(infoCode.code){
            case "migratingExistingUser":
                return {
                    ...eventAttributes,
                    reasonViewingScreen: "migratingUser"
                };
            case "existingUserSignupAttempt":
                return {
                    ...eventAttributes,
                    reasonViewingScreen: "existingUserSignupAttempt"
                };
            case "invitedUser":
                return {
                    ...eventAttributes,
                    reasonViewingScreen: "invitedUser"
                };
            default:
                return eventAttributes;
        }
        return eventAttributes;
    }, [
        infoCode
    ]);
    return appendReasonViewingScreen;
};

});
parcelRegister("jy3ZD", function(module, exports) {

$parcel$export(module.exports, "LoginHintType", function () { return $591c60b533905a63$export$39d1212c3512cb3a; });
$parcel$export(module.exports, "useLoginHint", function () { return $591c60b533905a63$export$76b5c17694a141a; });
$parcel$export(module.exports, "getEmailFromLoginHint", function () { return $591c60b533905a63$export$a738b9016987c561; });

var $91i6m = parcelRequire("91i6m");

var $l2v8Y = parcelRequire("l2v8Y");
var $591c60b533905a63$export$39d1212c3512cb3a;
(function(LoginHintType) {
    LoginHintType["EmailAddress"] = "email-address";
    LoginHintType["NotEmailAddress"] = "not-email-address";
})($591c60b533905a63$export$39d1212c3512cb3a || ($591c60b533905a63$export$39d1212c3512cb3a = {}));
const $591c60b533905a63$var$NEGATED_EMAIL_PREFIX = "not:";
function $591c60b533905a63$var$parseLoginHint(loginHint) {
    if (!loginHint) return undefined;
    if (loginHint.startsWith($591c60b533905a63$var$NEGATED_EMAIL_PREFIX)) return {
        type: "not-email-address",
        value: loginHint.substring($591c60b533905a63$var$NEGATED_EMAIL_PREFIX.length)
    };
    return {
        type: "email-address",
        value: loginHint
    };
}
const $591c60b533905a63$export$76b5c17694a141a = ()=>{
    const { search: search } = (0, $l2v8Y.useLocation)();
    return (0, $91i6m.useMemo)(()=>{
        const loginHint = new URLSearchParams(search).get("login_hint");
        return $591c60b533905a63$var$parseLoginHint(loginHint);
    }, [
        search
    ]);
};
const $591c60b533905a63$export$a738b9016987c561 = (loginHint)=>{
    if ((loginHint === null || loginHint === void 0 ? void 0 : loginHint.type) === "email-address") return loginHint.value;
};

});

parcelRegister("4rBM8", function(module, exports) {

$parcel$export(module.exports, "useLoginState", function () { return $c6628fb47e0e142f$export$bb159be17b1f5f11; });

var $6cMFi = parcelRequire("6cMFi");

var $gz8Vs = parcelRequire("gz8Vs");

var $2aGBJ = parcelRequire("2aGBJ");

var $k8MAo = parcelRequire("k8MAo");

var $91i6m = parcelRequire("91i6m");
const $c6628fb47e0e142f$var$usePreloadedState = ()=>{
    const appConfig = (0, $2aGBJ.useAppSelector)((state)=>state.appConfig);
    const csrfToken = (0, $2aGBJ.useAppSelector)((state)=>state.csrfToken);
    const cobranding = (0, $2aGBJ.useAppSelector)((state)=>state.cobranding);
    const hashedCsrfToken = (0, $2aGBJ.useAppSelector)((state)=>state.hashedCsrfToken);
    const login = (0, $2aGBJ.useAppSelector)((state)=>state.login);
    const oidcContext = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding.oidcContext);
    return {
        appConfig: appConfig,
        csrfToken: csrfToken,
        cobranding: cobranding,
        hashedCsrfToken: hashedCsrfToken,
        login: login,
        oidcContext: oidcContext
    };
};
const $c6628fb47e0e142f$export$bb159be17b1f5f11 = ()=>{
    const noServerState = (0, $6cMFi.default)();
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const { state: stateFromApi, isLoading: isLoading, isError: isError, error: error } = (0, $gz8Vs.usePageState)("/login/state", {
        enabled: noServerState
    });
    (0, $91i6m.useEffect)(()=>{
        if ((0, $gz8Vs.isPageStateResult)(stateFromApi)) dispatch((0, $k8MAo.loginSetState)(stateFromApi));
    }, [
        dispatch,
        stateFromApi
    ]);
    const preloadedState = $c6628fb47e0e142f$var$usePreloadedState();
    if ((0, $gz8Vs.isRedirectResult)(stateFromApi)) {
        window.location.assign(stateFromApi.uri);
        return {
            state: undefined,
            isLoading: true,
            isError: false
        };
    }
    if (noServerState) return {
        state: stateFromApi,
        isLoading: isLoading,
        isError: isError,
        error: error
    };
    return {
        state: preloadedState,
        isLoading: false,
        isError: false,
        error: error
    };
};

});
parcelRegister("k8MAo", function(module, exports) {

$parcel$export(module.exports, "checkUsernameCaptchaFailure", function () { return $1f9969ad83fb8729$export$c48d28459d63299c; });
$parcel$export(module.exports, "resetLoginForm", function () { return $1f9969ad83fb8729$export$6a45e1ba06bcfd40; });
$parcel$export(module.exports, "showFormErrors", function () { return $1f9969ad83fb8729$export$f89084e6f067bb43; });
$parcel$export(module.exports, "loginSetState", function () { return $1f9969ad83fb8729$export$10cc404412d31053; });
$parcel$export(module.exports, "checkUsername", function () { return $1f9969ad83fb8729$export$4929d86c6e4e281e; });
$parcel$export(module.exports, "loginUsernamePassword", function () { return $1f9969ad83fb8729$export$5391cc01902916c6; });
$parcel$export(module.exports, "loginPasswordless", function () { return $1f9969ad83fb8729$export$a6eaf375001ea98a; });

var $dBq8m = parcelRequire("dBq8m");

var $kU6Wu = parcelRequire("kU6Wu");

var $90yWB = parcelRequire("90yWB");

var $49Pnv = parcelRequire("49Pnv");

var $gtKO2 = parcelRequire("gtKO2");

var $fqbXQ = parcelRequire("fqbXQ");

var $1UkGo = parcelRequire("1UkGo");

var $kfTGh = parcelRequire("kfTGh");

var $hB2TQ = parcelRequire("hB2TQ");

var $4JAG5 = parcelRequire("4JAG5");
const $1f9969ad83fb8729$export$9cdc46fdb2ee9975 = (response)=>response.ok ? response : response.text().then((error)=>{
        throw new Error(error || response.statusText);
    });
const $1f9969ad83fb8729$export$46a04796807ec7cb = ()=>({
        type: "LOGIN_REQUEST_CHECK_USERNAME"
    });
const $1f9969ad83fb8729$export$2edff4284d04f803 = (userAction)=>({
        type: "LOGIN_REQUEST_CHECK_USERNAME_REDIRECT",
        redirectUrl: userAction.redirect_uri,
        redirectType: userAction.redirect_type
    });
const $1f9969ad83fb8729$export$5cc9c4683c14face = ()=>({
        type: "LOGIN_REQUEST_CHECK_USERNAME_SIGNUP"
    });
const $1f9969ad83fb8729$export$c7d021a470828fad = (userAction)=>({
        type: "LOGIN_REQUEST_CHECK_USERNAME_NO_ACTION",
        passwordless: userAction.passwordless || (0, $gtKO2.CheckUserNamePasswordlessType).Disallowed,
        social: userAction.social || "allowed"
    });
const $1f9969ad83fb8729$export$a7eb3c2b6fb70d6e = (userAction)=>({
        type: "LOGIN_REQUEST_CHECK_USERNAME_SOCIAL_LOGIN",
        passwordless: userAction.passwordless || (0, $gtKO2.CheckUserNamePasswordlessType).Disallowed,
        identities: userAction.identities
    });
const $1f9969ad83fb8729$var$requestCheckUsernameSucceeded = (userAction, analyticsClient)=>(dispatch)=>{
        switch(userAction.action){
            case "redirect":
                dispatch($1f9969ad83fb8729$export$2edff4284d04f803(userAction));
                break;
            case "signup":
                dispatch($1f9969ad83fb8729$export$5cc9c4683c14face());
                break;
            case "no_action":
                dispatch($1f9969ad83fb8729$export$c7d021a470828fad(userAction));
                break;
            case "social_login":
                if (!userAction.identities || userAction.identities.password === undefined) // this event is needed for growth team's experiment slo
                // we want to silently fire this event and not show any error
                // this will just not enrol user in the experiment
                analyticsClient.operationalEvent({
                    page: (0, $1UkGo.pageId),
                    action: "loadSocialLoginPage",
                    subject: "sli",
                    attributes: {
                        hasError: true,
                        errorName: "identities not as expected"
                    }
                });
                dispatch($1f9969ad83fb8729$export$a7eb3c2b6fb70d6e(userAction));
                break;
        }
        return Promise.resolve();
    };
const $1f9969ad83fb8729$export$c48d28459d63299c = (isOnline)=>$1f9969ad83fb8729$export$c445752097d9b598({
        code: isOnline ? "captcha" : "request_error"
    });
const $1f9969ad83fb8729$export$9cd96a2b004cc2f1 = (error)=>({
        type: "LOGIN_REQUEST_CHECK_USERNAME_FAILED",
        error: error
    });
const $1f9969ad83fb8729$export$c445752097d9b598 = (error)=>({
        type: "LOGIN_REQUEST_CHECK_USERNAME_ERROR",
        error: error
    });
const $1f9969ad83fb8729$export$6a45e1ba06bcfd40 = ()=>({
        type: "LOGIN_RESET"
    });
const $1f9969ad83fb8729$export$8a7c7d5c19ae03dc = ()=>({
        type: "LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN"
    });
const $1f9969ad83fb8729$export$e35197b32bd33011 = ()=>({
        type: "LOGIN_REQUEST_PASSWORDLESS_LOGIN"
    });
const $1f9969ad83fb8729$export$2195b30ff9688f1f = ()=>({
        type: "LOGIN_REQUEST_PASSWORDLESS_LOGIN_SUCCESS"
    });
const $1f9969ad83fb8729$export$9fbe8d742e3cfe1f = (error)=>({
        type: "LOGIN_REQUEST_PASSWORDLESS_LOGIN_FAILED",
        error: error
    });
const $1f9969ad83fb8729$export$8d0d1628cde4bf96 = (redirectUrl = "")=>({
        type: "LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN_SUCCESS",
        redirectUrl: redirectUrl
    });
const $1f9969ad83fb8729$export$72f5cc903fa26407 = (error)=>({
        type: "LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN_FAILED",
        error: error
    });
const $1f9969ad83fb8729$export$7598c3f25ced4803 = (redirectUrl)=>({
        type: "LOGIN_REDIRECT_USER",
        redirectUrl: redirectUrl
    });
const $1f9969ad83fb8729$export$84085369fb3df1bc = (nextAttempt)=>({
        type: "UPDATE_LOGIN_ATTEMPT_DETAILS",
        nextAttempt: nextAttempt
    });
const $1f9969ad83fb8729$export$3e87c66a234f33b9 = (isCaptchaRequired)=>({
        type: "LOGIN_UPDATE_CAPTCHA_REQUIREMENT",
        isCaptchaRequired: isCaptchaRequired
    });
const $1f9969ad83fb8729$export$f89084e6f067bb43 = (errors)=>({
        type: "LOGIN_SHOW_LOGIN_FORM_ERRORS",
        errors: errors
    });
const $1f9969ad83fb8729$export$10cc404412d31053 = (state)=>({
        type: "LOGIN_SET_STATE",
        state: state
    });
const $1f9969ad83fb8729$var$usernameCheck = ({ username: username, csrfToken: csrfToken, params: params, analyticsClient: analyticsClient, recoveryToken: recoveryToken, challengeResponse: challengeResponse })=>async (dispatch)=>{
        dispatch($1f9969ad83fb8729$export$46a04796807ec7cb());
        let response;
        try {
            response = await fetch(`/rest/check-username${params}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": csrfToken
                },
                body: JSON.stringify({
                    username: username,
                    recoveryToken: recoveryToken,
                    "challenge-response": (0, $4JAG5.toChallengeRequest)(challengeResponse)
                })
            });
        } catch (networkError) {
            analyticsClient.operationalEvent({
                page: (0, $1UkGo.pageId),
                action: "checkUsernameFailure",
                subject: "sli"
            });
            dispatch($1f9969ad83fb8729$export$c445752097d9b598({
                code: "request_error"
            }));
            return;
        }
        let analyticsAction;
        if (response.ok) try {
            dispatch($1f9969ad83fb8729$var$requestCheckUsernameSucceeded(await response.json(), analyticsClient));
            analyticsAction = "checkUsernameSuccessful";
        } catch (parseError) {
            dispatch($1f9969ad83fb8729$export$c445752097d9b598({
                code: "unknown"
            }));
            analyticsAction = "checkUsernameFailure";
        }
        else {
            analyticsAction = "checkUsernameFailure";
            let errorText = null;
            try {
                if (response.status === 429) dispatch($1f9969ad83fb8729$export$c445752097d9b598({
                    code: "too_many_username_requests"
                }));
                else if (response.status === 400) {
                    const { uiErrors: uiErrors } = await response.json();
                    if (uiErrors && uiErrors.length) dispatch($1f9969ad83fb8729$export$c445752097d9b598({
                        code: uiErrors[0].key || "unknown"
                    }));
                } else {
                    errorText = await response.text() || response.statusText;
                    const extractedError = JSON.parse(errorText).formErrors[0];
                    dispatch($1f9969ad83fb8729$export$9cd96a2b004cc2f1(extractedError));
                }
            } catch (parseError) {
                (0, $49Pnv.captureErrorMessage)("Username check failed", {
                    statusCode: response.status,
                    errorText: errorText,
                    errorMessage: parseError.message
                });
                dispatch($1f9969ad83fb8729$export$c445752097d9b598({
                    code: "unknown"
                }));
            }
        }
        analyticsClient.operationalEvent({
            page: (0, $1UkGo.pageId),
            action: analyticsAction,
            subject: "sli"
        });
    };
const $1f9969ad83fb8729$export$4929d86c6e4e281e = ({ username: username, params: params, analyticsClient: analyticsClient, recoveryToken: recoveryToken, challengeResponse: challengeResponse })=>(dispatch, getState)=>{
        analyticsClient.operationalEvent({
            page: (0, $1UkGo.pageId),
            action: "checkUsernameStart",
            subject: "sli"
        });
        return dispatch($1f9969ad83fb8729$var$usernameCheck({
            username: username,
            csrfToken: getState().csrfToken,
            params: params,
            analyticsClient: analyticsClient,
            recoveryToken: recoveryToken,
            challengeResponse: challengeResponse
        }));
    };
function $1f9969ad83fb8729$var$reportFrontendError(error) {
    function removeField(obj, fieldName) {
        for(const prop in obj){
            if (prop === fieldName) delete obj[prop];
            else if (typeof obj[prop] === "object") removeField(obj[prop], fieldName);
        }
    }
    function decodeJsonField(obj, path) {
        const val = (0, (/*@__PURE__*/$parcel$interopDefault($90yWB)))(obj, path);
        if (val !== "undefined") try {
            (0, (/*@__PURE__*/$parcel$interopDefault($kU6Wu)))(obj, path, JSON.parse(val));
        } catch (_) {}
    }
    removeField(error, "password");
    decodeJsonField(error, "original.response.text");
    const errorCode = error["error"];
    (0, $49Pnv.captureErrorMessage)(errorCode, {
        code: errorCode,
        errorPayload: error
    });
}
function $1f9969ad83fb8729$var$parseAdditionalData(err) {
    try {
        return JSON.parse(atob(err.error_description));
    } catch (e) {
        return {};
    }
}
function $1f9969ad83fb8729$var$handleLoginError(err, username, application, dispatch, getState, onLoginError) {
    const additionalData = $1f9969ad83fb8729$var$parseAdditionalData(err);
    const code = (additionalData["custom_error"] || err["error"] || "").toLowerCase();
    const isBitbucket = application && application.toLowerCase() === "bitbucket";
    if (code === "too_many_attempts" || code === "invalid_captcha") {
        dispatch($1f9969ad83fb8729$export$3e87c66a234f33b9(true));
        dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
            code: "captcha"
        }));
    } else if (code === "access_denied") {
        dispatch($1f9969ad83fb8729$export$84085369fb3df1bc(getState().login.nextAttempt + 1));
        dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
            code: "invalid_user_password"
        }));
    } else if (code === "ambiguous_user") dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
        code: "ambiguous_user"
    }));
    else if (code === "no_email_on_remote_user") dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
        code: "no_email_on_remote_user",
        args: {
            username: username
        }
    }));
    else if (code === "username_is_not_email") {
        const errorCode = isBitbucket ? "bitbucket_username_is_not_email" : "username_is_not_email";
        dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
            code: errorCode,
            args: {
                username: additionalData["email"]
            }
        }));
    } else if (code === "email_is_not_primary") {
        const errorCode = isBitbucket ? "bitbucket_email_is_not_primary" : "email_is_not_primary";
        dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
            code: errorCode,
            args: {
                username: additionalData["email"]
            }
        }));
    } else if (code === "too_many_logins") dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
        code: "too_many_logins"
    }));
    else if (code === "password_leaked") dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
        code: "password_leaked"
    }));
    else if (code === "blocked_user") {
        const redirectURL = application ? `/login/inactive?application=${application}` : "/login/inactive";
        dispatch($1f9969ad83fb8729$export$7598c3f25ced4803(redirectURL));
    } else if (code === "request_error") // 'request_error' auth0-js: connection fails due to offline or cross domain issue
    dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
        code: "request_error"
    }));
    else if (code === "invalid.session.token") dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
        code: "invalid.session.token"
    }));
    else {
        $1f9969ad83fb8729$var$reportFrontendError(err);
        dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
            code: "unknown"
        }));
    }
    if (code !== "too_many_attempts" && code !== "invalid_captcha") dispatch($1f9969ad83fb8729$export$3e87c66a234f33b9(false));
    onLoginError(code);
}
function $1f9969ad83fb8729$var$verifyCaptchaIfRequired(captchaValue, username) {
    if (!captchaValue) return Promise.resolve();
    return fetch("/rest/captcha/verify", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            "g-recaptcha-response": captchaValue,
            email: username
        })
    }).then($1f9969ad83fb8729$export$9cdc46fdb2ee9975).catch(()=>{
        const errorPayload = {};
        errorPayload["error"] = "invalid_captcha";
        return Promise.reject(errorPayload);
    });
}
const $1f9969ad83fb8729$export$beb986ec1c64324 = (csrfToken, config, marketingConsentState, anonymousId, userFlow)=>{
    let state = {
        csrfToken: csrfToken,
        anonymousId: anonymousId,
        userFlow: userFlow
    };
    const marketingConsent = (0, $fqbXQ.buildMarketingConsent)(config, marketingConsentState);
    if (marketingConsent) state = {
        ...state,
        marketingConsent: marketingConsent
    };
    return state;
};
const $1f9969ad83fb8729$export$5391cc01902916c6 = (loginParams)=>(dispatch, getState)=>{
        const { location: location, username: username, password: password, captchaValue: captchaValue, onLoginError: onLoginError, anonymousId: anonymousId } = loginParams;
        const params = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(location.search);
        const { application: application, userFlow: userFlow } = params;
        const state = getState();
        const { csrfToken: csrfToken, marketingConsent: marketingConsent } = state;
        dispatch($1f9969ad83fb8729$export$8a7c7d5c19ae03dc());
        const loginState = $1f9969ad83fb8729$export$beb986ec1c64324(csrfToken, marketingConsent.config, loginParams.marketingConsent, anonymousId, userFlow);
        const loginWithAtlassianAuth = ()=>(0, $kfTGh.login)({
                username: username,
                password: password,
                state: loginState,
                query: `${location.search}${location.hash}`
            }).then((result)=>{
                switch(result.kind){
                    case "failure":
                        const err = {
                            error: result.reason
                        };
                        return $1f9969ad83fb8729$var$handleLoginError(err, username, application, dispatch, getState, onLoginError);
                    case "success":
                        return window.location.assign(result.redirectUri);
                }
            });
        return $1f9969ad83fb8729$var$verifyCaptchaIfRequired(captchaValue, username).then(()=>loginWithAtlassianAuth()).catch((err)=>{
            (0, $49Pnv.captureException)(err);
            $1f9969ad83fb8729$var$handleLoginError(err, username, application, dispatch, getState, onLoginError);
        });
    };
const $1f9969ad83fb8729$export$a6eaf375001ea98a = ({ email: email, captchaValue: captchaValue, location: location })=>async (dispatch, getState)=>{
        const { csrfToken: csrfToken } = getState();
        dispatch($1f9969ad83fb8729$export$e35197b32bd33011());
        try {
            const response = await fetch(`/rest/login/passwordless${location.search}`, {
                method: "POST",
                headers: {
                    "X-CSRF-TOKEN": csrfToken,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email: email,
                    captchaValue: captchaValue
                })
            });
            const { csrfToken: newCsrfToken } = await response.json();
            if (newCsrfToken) dispatch((0, $hB2TQ.updateCsrfToken)(newCsrfToken));
            if (response.ok) {
                dispatch($1f9969ad83fb8729$export$2195b30ff9688f1f());
                return {
                    success: true
                };
            } else {
                dispatch($1f9969ad83fb8729$export$9fbe8d742e3cfe1f({
                    code: "unknown"
                }));
                return {
                    success: false
                };
            }
        } catch (error) {
            (0, $49Pnv.captureErrorMessage)(error.message, error);
            dispatch($1f9969ad83fb8729$export$9fbe8d742e3cfe1f({
                code: "request_error"
            }));
            return {
                success: false
            };
        }
    };

});
parcelRegister("90yWB", function(module, exports) {

var $i8cFE = parcelRequire("i8cFE");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $68ef3859172d2fc0$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $i8cFE(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $68ef3859172d2fc0$var$get;

});
parcelRegister("i8cFE", function(module, exports) {

var $f1LNj = parcelRequire("f1LNj");

var $lky4s = parcelRequire("lky4s");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $d332cd8476f88dbf$var$baseGet(object, path) {
    path = $f1LNj(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$lky4s(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $d332cd8476f88dbf$var$baseGet;

});


parcelRegister("kfTGh", function(module, exports) {

$parcel$export(module.exports, "login", function () { return $8630aadc7660b7c8$export$596d806903d1f59e; });

var $dBq8m = parcelRequire("dBq8m");

var $bqdjD = parcelRequire("bqdjD");
var $8630aadc7660b7c8$export$db7ad81c1149bb91;
(function(LoginFailureReason) {
    LoginFailureReason["AccessDenied"] = "access_denied";
    LoginFailureReason["PasswordLeaked"] = "password_leaked";
    LoginFailureReason["BlockedUser"] = "blocked_user";
    LoginFailureReason["TooManyAttempts"] = "too_many_attempts";
    LoginFailureReason["TooManyLogins"] = "too_many_logins";
})($8630aadc7660b7c8$export$db7ad81c1149bb91 || ($8630aadc7660b7c8$export$db7ad81c1149bb91 = {}));
var $8630aadc7660b7c8$export$5e64a9683d127ef6;
(function(LoginError) {
    LoginError["PreconditionFailed"] = "precondition_failed";
    LoginError["UnexpectedError"] = "unexpected_error";
})($8630aadc7660b7c8$export$5e64a9683d127ef6 || ($8630aadc7660b7c8$export$5e64a9683d127ef6 = {}));
function $8630aadc7660b7c8$var$failure(reason) {
    return {
        kind: "failure",
        reason: reason
    };
}
function $8630aadc7660b7c8$var$success(redirectUri) {
    return {
        kind: "success",
        redirectUri: redirectUri
    };
}

async function $8630aadc7660b7c8$export$596d806903d1f59e({ state: state, username: username, password: password, query: query }) {
    const isCommercial = (0, $bqdjD.getCurrentPerimeter)() === "commercial";
    const token = isCommercial ? await (parcelRequire("5uHPk")).then(async ({ createRequestToken: createRequestToken })=>await createRequestToken()).catch(()=>"") : null;
    return fetch(`/rest/authenticate${query}`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            username: username,
            password: password,
            state: state,
            ...token && {
                token: token
            }
        })
    }).then((response)=>{
        switch(response.status){
            case 200:
                return response.json().then((r)=>$8630aadc7660b7c8$var$success(r.redirectUri));
            case 403:
                return response.json().then((r)=>{
                    switch(r.error){
                        case "access_denied":
                            return $8630aadc7660b7c8$var$failure("access_denied");
                        case "blocked_user":
                            return $8630aadc7660b7c8$var$failure("blocked_user");
                        case "password_leaked":
                            return $8630aadc7660b7c8$var$failure("password_leaked");
                        case "too_many_attempts":
                            return $8630aadc7660b7c8$var$failure("too_many_attempts");
                        default:
                            return Promise.reject(new Error("unexpected_error"));
                    }
                });
            case 429:
                return response.json().then((r)=>r.error === "too_many_logins" ? $8630aadc7660b7c8$var$failure("too_many_logins") : Promise.reject(new Error("unexpected_error")));
            case 412:
                return response.json().then((r)=>{
                    switch(r.error){
                        case "mfa_required":
                            const currentQueryParams = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(window.location.search);
                            currentQueryParams.transactionToken = r.token;
                            const currentQueryString = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify(currentQueryParams);
                            return $8630aadc7660b7c8$var$success(`/login/mfa?${currentQueryString}`);
                        default:
                            return Promise.reject(new Error("precondition_failed"));
                    }
                });
            default:
                return Promise.reject(new Error("unexpected_error"));
        }
    });
}

});
parcelRegister("5uHPk", function(module, exports) {

var $2xbij = parcelRequire("2xbij");
module.exports = $2xbij("hQDxa").then(()=>parcelRequire("7FBZw"));

});


parcelRegister("hB2TQ", function(module, exports) {

$parcel$export(module.exports, "updateCsrfToken", function () { return $aae4dd533076dc9f$export$527f2c21586e0a0e; });
$parcel$export(module.exports, "updateHashedCsrfToken", function () { return $aae4dd533076dc9f$export$32d195f109b250f4; });
const $aae4dd533076dc9f$export$527f2c21586e0a0e = (csrfToken)=>({
        type: "CSRF_TOKEN_UPDATE",
        csrfToken: csrfToken
    });
const $aae4dd533076dc9f$export$32d195f109b250f4 = (hashedCsrfToken)=>({
        type: "HASHED_CSRF_TOKEN_UPDATE",
        hashedCsrfToken: hashedCsrfToken
    });

});



parcelRegister("h6aRF", function(module, exports) {
$parcel$export(module.exports, "useRegisterComponent", function () { return (parcelRequire("4PGUW")).useRegisterComponent; });
$parcel$export(module.exports, "PageOrchestrator", function () { return (parcelRequire("21dxG")).PageOrchestrator; });
$parcel$export(module.exports, "useShouldOrchestrate", function () { return (parcelRequire("ceIrb")).useShouldOrchestrate; });
parcelRequire("4PGUW");
parcelRequire("1A2bq");
parcelRequire("21dxG");
parcelRequire("d67cs");

});
parcelRegister("4PGUW", function(module, exports) {

$parcel$export(module.exports, "AdvancedCobrandingContext", function () { return $a83ddee780ae869d$export$5253ee94c7927efc; });
$parcel$export(module.exports, "useAdvancedCobrandingContext", function () { return $a83ddee780ae869d$export$12168a8568483640; });
$parcel$export(module.exports, "useRegisterComponent", function () { return $a83ddee780ae869d$export$24eaf8ff4dcf9c58; });

var $91i6m = parcelRequire("91i6m");
const $a83ddee780ae869d$export$5253ee94c7927efc = (0, $91i6m.createContext)(undefined);
const $a83ddee780ae869d$export$12168a8568483640 = ()=>{
    const context = (0, $91i6m.useContext)($a83ddee780ae869d$export$5253ee94c7927efc);
    if (!context) throw new Error("useAdvancedCobrandingContext used outside of AdvancedCobrandingContext");
    return context;
};
const $a83ddee780ae869d$export$24eaf8ff4dcf9c58 = (name)=>{
    const registered = (0, $91i6m.useRef)(false);
    const context = (0, $91i6m.useContext)($a83ddee780ae869d$export$5253ee94c7927efc);
    (0, $91i6m.useEffect)(()=>{
        if (registered.current) return;
        if (!context) return;
        registered.current = true;
        context.registerComponent(name);
    }, [
        context,
        name
    ]);
};

});

parcelRegister("1A2bq", function(module, exports) {

});

parcelRegister("21dxG", function(module, exports) {

$parcel$export(module.exports, "PageOrchestrator", function () { return $126e37a26cbc23db$export$ab5ed25a9459596a; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6IwzG = parcelRequire("6IwzG");

var $1V2cH = parcelRequire("1V2cH");

var $4PGUW = parcelRequire("4PGUW");

var $d55RL = parcelRequire("d55RL");

var $3jGGb = parcelRequire("3jGGb");
const $126e37a26cbc23db$export$ab5ed25a9459596a = ({ fallback: fallback, pages: pages, requiredComponents: requiredComponents })=>{
    const [registrationStarted, setRegistrationStarted] = (0, $91i6m.useState)(false);
    const [components, setComponents] = (0, $91i6m.useState)();
    const { cobranding: cobranding } = (0, $6IwzG.useCobranding)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const page = (0, $91i6m.useMemo)(()=>{
        return pages.find((page)=>page.cobranding === cobranding);
    }, [
        pages,
        cobranding
    ]);
    const Component = (0, $91i6m.useMemo)(()=>{
        return (page === null || page === void 0 ? void 0 : page.Component) || fallback;
    }, [
        page,
        fallback
    ]);
    const registerComponent = (0, $91i6m.useCallback)((component)=>{
        setComponents((components)=>{
            return components ? [
                ...components,
                component
            ] : [
                component
            ];
        });
    }, []);
    const value = (0, $91i6m.useMemo)(()=>({
            components: components,
            registerComponent: registerComponent
        }), [
        components,
        registerComponent
    ]);
    (0, $91i6m.useEffect)(()=>{
        setTimeout(()=>setRegistrationStarted(true), 0);
    }, []);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4PGUW.AdvancedCobrandingContext).Provider, {
        value: value,
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $d55RL.PageGuard), {
            requiredComponents: requiredComponents,
            registrationStarted: registrationStarted,
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $3jGGb.default), {
                analyticsClient: analyticsClient,
                children: /*#__PURE__*/ (0, $4ZSso.jsx)(Component, {})
            })
        })
    });
};

});
parcelRegister("d55RL", function(module, exports) {

$parcel$export(module.exports, "PageGuard", function () { return $c86123a08353b2a4$export$c2e3d7bea8403012; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6IwzG = parcelRequire("6IwzG");

var $4PGUW = parcelRequire("4PGUW");

var $9OWP7 = parcelRequire("9OWP7");
const $c86123a08353b2a4$export$308d0668fb31657f = 2000;
const $c86123a08353b2a4$var$canShowOverlay = false;
const $c86123a08353b2a4$export$c2e3d7bea8403012 = ({ children: children, requiredComponents: requiredComponents, registrationStarted: registrationStarted })=>{
    const { cobranding: cobranding } = (0, $6IwzG.useCobranding)();
    const { components: components } = (0, $4PGUW.useAdvancedCobrandingContext)();
    const [registrationTimedOut, setRegistrationTimedOut] = (0, $91i6m.useState)(false);
    const missingComponents = (0, $91i6m.useMemo)(()=>{
        return requiredComponents.filter((requiredComponent)=>!(components === null || components === void 0 ? void 0 : components.includes(requiredComponent)));
    }, [
        requiredComponents,
        components
    ]);
    (0, $91i6m.useEffect)(()=>{
        if (!registrationStarted) return;
        const timeout = setTimeout(()=>{
            setRegistrationTimedOut(true);
        }, $c86123a08353b2a4$export$308d0668fb31657f);
        return ()=>clearTimeout(timeout);
    }, [
        registrationStarted
    ]);
    const hasRegisteredAllRequiredComponents = missingComponents.length === 0;
    const isWaitingForRegistration = !registrationTimedOut;
    (0, $91i6m.useEffect)(()=>{
        if (!hasRegisteredAllRequiredComponents && !isWaitingForRegistration && !$c86123a08353b2a4$var$canShowOverlay) console.warn(`[COBRANDING] ${window.location.pathname} has not registered all required components.`);
    }, [
        cobranding,
        hasRegisteredAllRequiredComponents,
        isWaitingForRegistration
    ]);
    if (hasRegisteredAllRequiredComponents) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $91i6m.Suspense), {
        fallback: /*#__PURE__*/ (0, $4ZSso.jsx)($c86123a08353b2a4$var$LoadingOverlay, {}),
        children: /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
            "data-testid": "registration-complete",
            children: children
        })
    });
    if (isWaitingForRegistration || !$c86123a08353b2a4$var$canShowOverlay) // Displays the loading overlay while the page is lazy-loading and while the registration is in progress.
    // OR if we can't show the overlay (i.e. this is prod/staging) then we let the experiment render
    return /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $91i6m.Suspense), {
        fallback: /*#__PURE__*/ (0, $4ZSso.jsx)($c86123a08353b2a4$var$LoadingOverlay, {}),
        children: [
            children,
            /*#__PURE__*/ (0, $4ZSso.jsx)($c86123a08353b2a4$var$LoadingOverlay, {})
        ]
    });
    return /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
        "data-testid": "registration-complete",
        children: /*#__PURE__*/ (0, $4ZSso.jsx)($c86123a08353b2a4$var$MissingComponentErrorDisplay, {
            cobranding: cobranding,
            missingComponents: missingComponents,
            children: children
        })
    });
};
const $c86123a08353b2a4$var$MissingComponentErrorDisplay = ({ cobranding: cobranding, missingComponents: missingComponents, children: children })=>{
    const search = new URLSearchParams(window.location.search);
    search.delete("token");
    return /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
                style: {
                    position: "fixed",
                    zIndex: 100,
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    alignItems: "center",
                    justifyContent: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
                        style: {
                            position: "fixed",
                            zIndex: -1,
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            opacity: 0.25,
                            backgroundColor: "#FFADB0"
                        }
                    }),
                    /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "1rem",
                            padding: "4rem",
                            borderRadius: "0.5rem",
                            background: "#FFADB0",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "0.25rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $4ZSso.jsx)("h2", {
                                        style: {
                                            fontWeight: "bold"
                                        },
                                        children: "Advanced Cobranding"
                                    }),
                                    /*#__PURE__*/ (0, $4ZSso.jsx)("p", {
                                        children: "Unable to render page due to missing required components:"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "0.1rem",
                                    padding: "1rem",
                                    borderRadius: "0.25rem",
                                    color: "white",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "#c92216"
                                },
                                children: missingComponents.map((component)=>/*#__PURE__*/ (0, $4ZSso.jsx)("p", {
                                        style: {
                                            margin: 0
                                        },
                                        children: /*#__PURE__*/ (0, $4ZSso.jsx)("span", {
                                            "data-testid": "missing-component",
                                            children: component
                                        })
                                    }, component))
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "0.25rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $4ZSso.jsxs)("p", {
                                        style: {
                                            margin: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $4ZSso.jsx)("strong", {
                                                children: "Cobranding"
                                            }),
                                            ": ",
                                            cobranding
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4ZSso.jsxs)("p", {
                                        style: {
                                            margin: 0,
                                            display: "flex",
                                            flexWrap: "wrap"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $4ZSso.jsx)("strong", {
                                                children: "URL"
                                            }),
                                            ": ",
                                            `${window.location.pathname}?${search}`
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            children
        ]
    });
};
const $c86123a08353b2a4$var$LoadingOverlay = ()=>/*#__PURE__*/ (0, $4ZSso.jsx)("div", {
        style: {
            position: "fixed",
            top: 0,
            zIndex: 2,
            pointerEvents: "none",
            left: 0,
            right: 0,
            bottom: 0,
            flexDirection: "column",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "white"
        },
        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9OWP7.default), {})
    });

});


parcelRegister("d67cs", function(module, exports) {
$parcel$export(module.exports, "useShouldOrchestrate", function () { return (parcelRequire("ceIrb")).useShouldOrchestrate; });
parcelRequire("ceIrb");

});
parcelRegister("ceIrb", function(module, exports) {

$parcel$export(module.exports, "useShouldOrchestrate", function () { return $aeedbd6776550638$export$eab7ff4ea760bf6a; });

var $6IwzG = parcelRequire("6IwzG");
const $aeedbd6776550638$export$eab7ff4ea760bf6a = ()=>{
    const { cobranding: cobranding } = (0, $6IwzG.useCobranding)();
    const forceOrchestration = (0, $6IwzG.isAdvancedCobranding)(cobranding);
    return forceOrchestration;
};

});





parcelRegister("6eNI5", function(module, exports) {

$parcel$export(module.exports, "LoginTooManyAttemptsRecaptchaContextProvider", function () { return $7e5c617ff15320cb$export$b27cbe0302f9b08b; });
$parcel$export(module.exports, "useLoginTooManyAttemptsRecaptchaContext", function () { return $7e5c617ff15320cb$export$5c1b73ca6a070fab; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $2aGBJ = parcelRequire("2aGBJ");
const $7e5c617ff15320cb$export$d98a10b0f5602870 = /*#__PURE__*/ (0, $91i6m.createContext)(null);
const $7e5c617ff15320cb$export$b27cbe0302f9b08b = ({ children: children })=>{
    const [captchaValue, setCaptchaValue] = (0, $91i6m.useState)(null);
    const isRequired = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isCaptchaRequired;
    });
    const value = (0, $91i6m.useMemo)(()=>({
            isRequired: isRequired,
            captchaValue: captchaValue,
            setCaptchaValue: setCaptchaValue
        }), [
        captchaValue,
        setCaptchaValue,
        isRequired
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)($7e5c617ff15320cb$export$d98a10b0f5602870.Provider, {
        value: value,
        children: children
    });
};
const $7e5c617ff15320cb$export$5c1b73ca6a070fab = ()=>{
    const context = (0, $91i6m.useContext)($7e5c617ff15320cb$export$d98a10b0f5602870);
    if (!context) throw new Error("useLoginTooManyAttemptsRecaptchaContext must be used within a LoginTooManyAttemptsRecaptchaContextProvider");
    return context;
};

});

parcelRegister("fALlm", function(module, exports) {

$parcel$export(module.exports, "LoginRecoveryOptionsContextProvider", function () { return $2c694d7ec2ab16d2$export$4df382a2361d8131; });
$parcel$export(module.exports, "useLoginRecoveryOptionsContext", function () { return $2c694d7ec2ab16d2$export$402ee3e11776bab7; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");
const $2c694d7ec2ab16d2$export$84bd9b573c96976b = /*#__PURE__*/ (0, $91i6m.createContext)(null);
const $2c694d7ec2ab16d2$export$4df382a2361d8131 = ({ children: children })=>{
    const [loginRecoveryOptions, setLoginRecoveryOptions] = (0, $91i6m.useState)();
    const value = (0, $91i6m.useMemo)(()=>({
            loginRecoveryOptions: loginRecoveryOptions,
            setLoginRecoveryOptions: setLoginRecoveryOptions
        }), [
        loginRecoveryOptions
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)($2c694d7ec2ab16d2$export$84bd9b573c96976b.Provider, {
        value: value,
        children: children
    });
};
const $2c694d7ec2ab16d2$export$402ee3e11776bab7 = ()=>{
    const context = (0, $91i6m.useContext)($2c694d7ec2ab16d2$export$84bd9b573c96976b);
    if (!context) throw new Error("useLoginRecoveryOptionsContext must be used within a LoginRecoveryOptionsContextProvider");
    return context;
};

});

parcelRegister("4HGiq", function(module, exports) {

$parcel$export(module.exports, "LoginGoogleOneTapRenderBoundary", function () { return $2485820e2931b4d6$export$bc9e03527d642019; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $9OWP7 = parcelRequire("9OWP7");

var $1rFqe = parcelRequire("1rFqe");

var $i888P = parcelRequire("i888P");

var $4rBM8 = parcelRequire("4rBM8");

var $1UkGo = parcelRequire("1UkGo");

var $fALlm = parcelRequire("fALlm");

var $h6Rwg = parcelRequire("h6Rwg");
const $2485820e2931b4d6$export$bc9e03527d642019 = ({ children: children })=>{
    const { loginRecoveryOptions: loginRecoveryOptions } = (0, $fALlm.useLoginRecoveryOptionsContext)();
    const { isGoogleOneTapDismissed: isGoogleOneTapDismissed } = (0, $h6Rwg.useSocialLogin)();
    const { state: state, isLoading: isPageStateLoading, error: pageStateError } = (0, $4rBM8.useLoginState)();
    if (isPageStateLoading) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9OWP7.default), {
        label: "Login page loading"
    });
    else if (!state || pageStateError) throw new Error(`Page state loading unsuccessful. \nPage state error: ${pageStateError}`);
    const { googleAuthClientId: googleAuthClientId } = state.appConfig;
    const { hashedCsrfToken: hashedCsrfToken } = state;
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $1rFqe.default), {
        csrfToken: hashedCsrfToken !== null && hashedCsrfToken !== void 0 ? hashedCsrfToken : "token-should-be-loaded",
        googleAuthClientId: googleAuthClientId,
        source: (0, $1UkGo.pageId),
        enabled: !isGoogleOneTapDismissed && (0, $i888P.isBooleanFeatureFlagSet)("identity.aid-frontend.google.one.tap.enabled"),
        recoveryOptions: loginRecoveryOptions,
        children: children
    });
};

});
parcelRegister("1rFqe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a17c37a69764cd5$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $8hJHo = parcelRequire("8hJHo");

var $ccxRw = parcelRequire("ccxRw");

var $dBq8m = parcelRequire("dBq8m");

var $g7xf6 = parcelRequire("g7xf6");

var $1V2cH = parcelRequire("1V2cH");

var $bqdjD = parcelRequire("bqdjD");
const $3a17c37a69764cd5$var$oneTapClientUrl = "https://accounts.google.com/gsi/client";
const $3a17c37a69764cd5$export$dc57f6202fda5ffc = ({ children: children, csrfToken: csrfToken, enabled: enabled, google: google, googleAuthClientId: googleAuthClientId, recoveryOptions: recoveryOptions, source: source })=>{
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    (0, $91i6m.useEffect)(()=>{
        var _google_accounts;
        const isCommercial = (0, $bqdjD.currentPerimeter) === "commercial";
        if ((google === null || google === void 0 ? void 0 : (_google_accounts = google.accounts) === null || _google_accounts === void 0 ? void 0 : _google_accounts.id) && enabled && isCommercial) {
            google.accounts.id.initialize({
                client_id: googleAuthClientId,
                cancel_on_tap_outside: false,
                use_fedcm_for_prompt: true,
                itp_support: false,
                callback: (credentialResponse)=>{
                    analyticsClient.buttonClickedEvent(source, "googleYoloAccountSelected");
                    const { userFlow: userFlow } = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(window.location.search);
                    const callbackBase = `${window.location.origin}/login/google`;
                    const callbackParams = {
                        state: (0, $ccxRw.buildState)({
                            location: window.location,
                            csrfToken: csrfToken,
                            source: source,
                            loginType: (0, $ccxRw.LoginType).GoogleOneTap,
                            anonymousId: analyticsClient.getAnonymousId(),
                            userFlow: userFlow,
                            recoveryOptions: recoveryOptions
                        })
                    };
                    (0, $g7xf6.default)({
                        method: "POST",
                        action: `${callbackBase}?${(0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify(callbackParams)}`,
                        payload: {
                            id_token: credentialResponse.credential
                        }
                    });
                }
            });
            google.accounts.id.prompt((notification)=>{
                if (notification.isDismissedMoment()) {
                    const reason = notification.getDismissedReason();
                    analyticsClient.buttonClickedEvent(source, "googleYoloDismissed", {
                        reason: reason
                    });
                }
            });
        }
        return ()=>{
            var _google_accounts_id, _google_accounts;
            return google === null || google === void 0 ? void 0 : (_google_accounts = google.accounts) === null || _google_accounts === void 0 ? void 0 : (_google_accounts_id = _google_accounts.id) === null || _google_accounts_id === void 0 ? void 0 : _google_accounts_id.cancel();
        };
    }, [
        google,
        enabled,
        googleAuthClientId,
        csrfToken,
        analyticsClient,
        source,
        recoveryOptions
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4ZSso.Fragment), {
        children: children
    });
};
var $3a17c37a69764cd5$export$2e2bcd8739ae039 = (0, $8hJHo.default)($3a17c37a69764cd5$var$oneTapClientUrl, {
    globalName: "google",
    attributes: {
        nonce: window.cspNonce
    }
})($3a17c37a69764cd5$export$dc57f6202fda5ffc);

});
parcelRegister("8hJHo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60835c15747f25e9$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $eYOCy = parcelRequire("eYOCy");

var $kTpRR = parcelRequire("kTpRR");
function $60835c15747f25e9$var$_extends() {
    $60835c15747f25e9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $60835c15747f25e9$var$_extends.apply(this, arguments);
}
function $60835c15747f25e9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $60835c15747f25e9$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $60835c15747f25e9$var$SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function
var $60835c15747f25e9$var$idCount = 0;
function $60835c15747f25e9$export$2e2bcd8739ae039(getScriptURL, options) {
    options = options || {};
    return function wrapWithAsyncScript(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var AsyncScriptLoader = /*#__PURE__*/ function(_Component) {
            $60835c15747f25e9$var$_inheritsLoose(AsyncScriptLoader, _Component);
            function AsyncScriptLoader(props, context) {
                var _this;
                _this = _Component.call(this, props, context) || this;
                _this.state = {};
                _this.__scriptURL = "";
                return _this;
            }
            var _proto = AsyncScriptLoader.prototype;
            _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
                if (!this.__scriptLoaderID) this.__scriptLoaderID = "async-script-loader-" + $60835c15747f25e9$var$idCount++;
                return this.__scriptLoaderID;
            };
            _proto.setupScriptURL = function setupScriptURL() {
                this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
                return this.__scriptURL;
            };
            _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
                var _this2 = this;
                // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
                this.setState(state, function() {
                    return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
                });
            };
            _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
                var mapEntry = $60835c15747f25e9$var$SCRIPT_MAP[this.__scriptURL];
                if (!mapEntry || !mapEntry.loaded) throw new Error("Script is not loaded.");
                for(var obsKey in mapEntry.observers)mapEntry.observers[obsKey](mapEntry);
                delete window[options.callbackName];
            };
            _proto.componentDidMount = function componentDidMount() {
                var _this3 = this;
                var scriptURL = this.setupScriptURL();
                var key = this.asyncScriptLoaderGetScriptLoaderID();
                var _options = options, globalName = _options.globalName, callbackName = _options.callbackName, scriptId = _options.scriptId; // check if global object already attached to window
                if (globalName && typeof window[globalName] !== "undefined") $60835c15747f25e9$var$SCRIPT_MAP[scriptURL] = {
                    loaded: true,
                    observers: {}
                };
                 // check if script loading already
                if ($60835c15747f25e9$var$SCRIPT_MAP[scriptURL]) {
                    var entry = $60835c15747f25e9$var$SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"
                    if (entry && (entry.loaded || entry.errored)) {
                        this.asyncScriptLoaderHandleLoad(entry);
                        return;
                    } // if still loading then callback to observer queue
                    entry.observers[key] = function(entry) {
                        return _this3.asyncScriptLoaderHandleLoad(entry);
                    };
                    return;
                }
                /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */ var observers = {};
                observers[key] = function(entry) {
                    return _this3.asyncScriptLoaderHandleLoad(entry);
                };
                $60835c15747f25e9$var$SCRIPT_MAP[scriptURL] = {
                    loaded: false,
                    observers: observers
                };
                var script = document.createElement("script");
                script.src = scriptURL;
                script.async = true;
                for(var attribute in options.attributes)script.setAttribute(attribute, options.attributes[attribute]);
                if (scriptId) script.id = scriptId;
                var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
                    if ($60835c15747f25e9$var$SCRIPT_MAP[scriptURL]) {
                        var mapEntry = $60835c15747f25e9$var$SCRIPT_MAP[scriptURL];
                        var observersMap = mapEntry.observers;
                        for(var obsKey in observersMap)if (func(observersMap[obsKey])) delete observersMap[obsKey];
                    }
                };
                if (callbackName && typeof window !== "undefined") window[callbackName] = function() {
                    return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
                };
                script.onload = function() {
                    var mapEntry = $60835c15747f25e9$var$SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.loaded = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            if (callbackName) return false;
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                script.onerror = function() {
                    var mapEntry = $60835c15747f25e9$var$SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.errored = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                document.body.appendChild(script);
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                // Remove tag script
                var scriptURL = this.__scriptURL;
                if (options.removeOnUnmount === true) {
                    var allScripts = document.getElementsByTagName("script");
                    for(var i = 0; i < allScripts.length; i += 1){
                        if (allScripts[i].src.indexOf(scriptURL) > -1) {
                            if (allScripts[i].parentNode) allScripts[i].parentNode.removeChild(allScripts[i]);
                        }
                    }
                } // Clean the observer entry
                var mapEntry = $60835c15747f25e9$var$SCRIPT_MAP[scriptURL];
                if (mapEntry) {
                    delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];
                    if (options.removeOnUnmount === true) delete $60835c15747f25e9$var$SCRIPT_MAP[scriptURL];
                }
            };
            _proto.render = function render() {
                var globalName = options.globalName; // remove asyncScriptOnLoad from childProps
                var _this$props = this.props, asyncScriptOnLoad = _this$props.asyncScriptOnLoad, forwardedRef = _this$props.forwardedRef, childProps = $60835c15747f25e9$var$_objectWithoutPropertiesLoose(_this$props, [
                    "asyncScriptOnLoad",
                    "forwardedRef"
                ]); // eslint-disable-line no-unused-vars
                if (globalName && typeof window !== "undefined") childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
                childProps.ref = forwardedRef;
                return (0, $91i6m.createElement)(WrappedComponent, childProps);
            };
            return AsyncScriptLoader;
        }((0, $91i6m.Component)); // Note the second param "ref" provided by React.forwardRef.
        // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
        // And it can then be attached to the Component.
        var ForwardedComponent = (0, $91i6m.forwardRef)(function(props, ref) {
            return (0, $91i6m.createElement)(AsyncScriptLoader, $60835c15747f25e9$var$_extends({}, props, {
                forwardedRef: ref
            }));
        });
        ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
        ForwardedComponent.propTypes = {
            asyncScriptOnLoad: (0, (/*@__PURE__*/$parcel$interopDefault($eYOCy))).func
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($kTpRR)))(ForwardedComponent, WrappedComponent);
    };
}

});

parcelRegister("g7xf6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dceb0d2fa4ff3245$export$2e2bcd8739ae039; });
function $dceb0d2fa4ff3245$export$2e2bcd8739ae039({ method: method, action: action = "", payload: payload, skipSanitizationKeys: skipSanitizationKeys = [] }) {
    const form = document.createElement("form");
    form.style.display = "none";
    form.method = method;
    form.action = action;
    if (payload) Object.entries(payload).filter(([, value])=>value != null).forEach(([name, value])=>{
        const input = document.createElement("input");
        input.name = $dceb0d2fa4ff3245$var$sanitizeInput(name);
        input.value = skipSanitizationKeys.includes(name) ? String(value) : $dceb0d2fa4ff3245$var$sanitizeInput(String(value));
        form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
}
/**
 * This function takes an input string, assigns it to the textContent property of a newly created div,
 * and then returns the sanitized HTML content of the div. Since textContent does not parse HTML,
 * any harmful tags or scripts in the input will be treated as plain text, not as code.
 *
 * i.e.:
 * sanitizeInput("<script>window.alert('hi')</script>") -> "&lt;script&gt;window.alert('hi')&lt;/script&gt;"
 *
 * https://asecurityteam.atlassian.net/browse/VULN-1229071
 */ function $dceb0d2fa4ff3245$var$sanitizeInput(input) {
    const div = document.createElement("div");
    div.textContent = input;
    return div.innerHTML;
}

});


parcelRegister("h6Rwg", function(module, exports) {

$parcel$export(module.exports, "useSocialLogin", function () { return $8c11096978e34221$export$c599a88026ac50ef; });

var $91i6m = parcelRequire("91i6m");

var $6d87w = parcelRequire("6d87w");

var $1SKGt = parcelRequire("1SKGt");

var $2aGBJ = parcelRequire("2aGBJ");

var $gtKO2 = parcelRequire("gtKO2");

var $1V2cH = parcelRequire("1V2cH");

var $bqdjD = parcelRequire("bqdjD");

var $4rBM8 = parcelRequire("4rBM8");

var $ccxRw = parcelRequire("ccxRw");

var $7JGKf = parcelRequire("7JGKf");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $1UkGo = parcelRequire("1UkGo");

var $NAfW5 = parcelRequire("NAfW5");
const $8c11096978e34221$export$c599a88026ac50ef = ()=>{
    (0, $4PGUW.useRegisterComponent)($8c11096978e34221$export$c599a88026ac50ef.name);
    const isCommercial = (0, $bqdjD.getCurrentPerimeter)() === "commercial";
    const location = (0, $6d87w.useLocation)();
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const appendReasonViewingScreen = (0, $NAfW5.useAppendReasonViewingScreen)();
    const isUsernameChecked = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isUsernameChecked;
    });
    const identities = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.identities;
    });
    const isLoginSecondStep = isUsernameChecked;
    const isGoogleOneTapDismissed = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_googleOneTap;
        return state === null || state === void 0 ? void 0 : (_state_googleOneTap = state.googleOneTap) === null || _state_googleOneTap === void 0 ? void 0 : _state_googleOneTap.dismissed;
    });
    const isSocialBlocked = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isSocialBlocked;
    });
    const { errorCode: errorCode } = (0, $NAfW5.useSearchParamCodes)();
    const { state: state } = (0, $4rBM8.useLoginState)();
    const { appConfig: appConfig, csrfToken: csrfToken } = state || {};
    const application = (0, $NAfW5.useCobrandingApplication)();
    const socialLoginEligibility = (0, $91i6m.useMemo)(()=>(0, $7JGKf.getSocialLoginEligibility)(identities, location, application), [
        application,
        identities,
        location
    ]);
    const { highlightedSocialProvider: highlightedSocialProvider, isEligibleForSocialLoginOnly: isEligibleForSocialLoginOnly } = socialLoginEligibility;
    const showSocialLoginOnly = isLoginSecondStep && isEligibleForSocialLoginOnly && highlightedSocialProvider && isCommercial;
    const socialButtonClickedEvent = (0, $91i6m.useCallback)((socialProvider)=>{
        analyticsClient.buttonClickedEvent(showSocialLoginOnly ? "socialLoginForm" : (0, $1UkGo.pageId), `${socialProvider}LoginButton`, appendReasonViewingScreen({}));
    }, [
        analyticsClient,
        appendReasonViewingScreen,
        showSocialLoginOnly
    ]);
    const loginRecoveryOptions = (0, $NAfW5.useLoginRecoveryOptions)();
    const handleGoogleSocialLogin = (0, $91i6m.useCallback)((email)=>{
        socialButtonClickedEvent((0, $gtKO2.SocialProvider).Google);
        (0, $ccxRw.redirectToGoogleLogin)({
            location: window.location,
            source: (0, $1UkGo.pageId),
            recoveryOptions: loginRecoveryOptions(email)
        });
    }, [
        loginRecoveryOptions,
        socialButtonClickedEvent
    ]);
    const handleAuth0SocialLogin = (0, $91i6m.useCallback)((socialProvider, email, redirectFn)=>{
        socialButtonClickedEvent(socialProvider);
        redirectFn({
            location: window.location,
            auth0Config: appConfig === null || appConfig === void 0 ? void 0 : appConfig.auth0Config,
            csrfToken: csrfToken !== null && csrfToken !== void 0 ? csrfToken : "token-should-be-loaded",
            source: (0, $1UkGo.pageId),
            email: email || undefined,
            recoveryOptions: loginRecoveryOptions(email)
        });
    }, [
        appConfig === null || appConfig === void 0 ? void 0 : appConfig.auth0Config,
        csrfToken,
        loginRecoveryOptions,
        socialButtonClickedEvent
    ]);
    const handleMicrosoftLogin = (0, $91i6m.useCallback)((email)=>handleAuth0SocialLogin((0, $gtKO2.SocialProvider).Microsoft, email, (0, $ccxRw.redirectToMicrosoftLogin)), [
        handleAuth0SocialLogin
    ]);
    const handleAppleLogin = (0, $91i6m.useCallback)((email)=>handleAuth0SocialLogin((0, $gtKO2.SocialProvider).Apple, email, (0, $ccxRw.redirectToAppleLogin)), [
        handleAuth0SocialLogin
    ]);
    const handleSlackLogin = (0, $91i6m.useCallback)((email)=>handleAuth0SocialLogin((0, $gtKO2.SocialProvider).Slack, email, (0, $ccxRw.redirectToSlackLogin)), [
        handleAuth0SocialLogin
    ]);
    const onDismissGoogleOneTap = (0, $91i6m.useCallback)(()=>dispatch((0, $1SKGt.dismissGoogleOneTap)()), [
        dispatch
    ]);
    const isCheckingUsername = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isCheckingUsername;
    });
    const isLoggingIn = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isLoggingIn;
    });
    const usernameExists = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.usernameExists;
    });
    const isLoading = isCheckingUsername || isLoggingIn;
    (0, $91i6m.useEffect)(()=>{
        if (!isLoading && isLoginSecondStep && usernameExists && identities) analyticsClient.trackingEvent({
            page: (0, $1UkGo.pageId),
            action: "triggered",
            subject: "loginSecondStep",
            attributes: {
                eligibility: socialLoginEligibility
            }
        });
    }, [
        analyticsClient,
        identities,
        isLoading,
        isLoginSecondStep,
        socialLoginEligibility,
        usernameExists
    ]);
    if (isCommercial) return {
        envSupportsSocialLogin: true,
        socialLoginEligibility: socialLoginEligibility,
        onAppleLogin: handleAppleLogin,
        onSlackLogin: handleSlackLogin,
        onMicrosoftLogin: handleMicrosoftLogin,
        onGoogleSocialLogin: handleGoogleSocialLogin,
        onDismissGoogleOneTap: onDismissGoogleOneTap,
        isGoogleOneTapDismissed: isGoogleOneTapDismissed,
        isSocialBlocked: isSocialBlocked || (errorCode === null || errorCode === void 0 ? void 0 : errorCode.code) === "social_login_banned"
    };
    return {
        envSupportsSocialLogin: false,
        socialLoginEligibility: null,
        onAppleLogin: null,
        onSlackLogin: null,
        onMicrosoftLogin: null,
        onGoogleSocialLogin: null,
        onDismissGoogleOneTap: null,
        isGoogleOneTapDismissed: null,
        isSocialBlocked: false
    };
};

});
parcelRegister("1SKGt", function(module, exports) {

$parcel$export(module.exports, "dismissGoogleOneTap", function () { return $d1fead2b0aa97e4d$export$7634a565805a5f09; });
const $d1fead2b0aa97e4d$export$7634a565805a5f09 = ()=>({
        type: "GOOGLE_ONE_TAP_DISMISS"
    });

});

parcelRegister("7JGKf", function(module, exports) {

$parcel$export(module.exports, "getSocialLoginEligibility", function () { return $fea9e4b105970f8f$export$e8b4b1bf168dca09; });

var $gtKO2 = parcelRequire("gtKO2");

var $ccxRw = parcelRequire("ccxRw");
const $fea9e4b105970f8f$export$98889b02384daf87 = [
    (0, $gtKO2.SocialProvider).Google,
    (0, $gtKO2.SocialProvider).Microsoft,
    (0, $gtKO2.SocialProvider).Apple,
    (0, $gtKO2.SocialProvider).Slack
];
const $fea9e4b105970f8f$var$socialProviderToHighPriorityPredicate = {
    [(0, $gtKO2.SocialProvider).Google]: ()=>!(0, $ccxRw.isGoogleLoginOutageAdvisoryEnabled)(),
    [(0, $gtKO2.SocialProvider).Microsoft]: ()=>!(0, $ccxRw.isMicrosoftLoginOutageAdvisoryEnabled)(),
    [(0, $gtKO2.SocialProvider).Apple]: ()=>!(0, $ccxRw.isAppleLoginOutageAdvisoryEnabled)(),
    [(0, $gtKO2.SocialProvider).Slack]: ()=>!(0, $ccxRw.isSlackLoginOutageAdvisoryEnabled)()
};
const $fea9e4b105970f8f$export$94af6b531db26586 = ()=>{
    const highPriority = [];
    const lowPriority = [];
    $fea9e4b105970f8f$export$98889b02384daf87.forEach((provider)=>{
        const isHighPriority = $fea9e4b105970f8f$var$socialProviderToHighPriorityPredicate[provider];
        if (isHighPriority && !isHighPriority()) lowPriority.push(provider);
        else // No predicate means no definition of low priority, so it must be high priority.
        highPriority.push(provider);
    });
    return highPriority.concat(lowPriority);
};
const $fea9e4b105970f8f$export$47bb6da133b3804e = (connected, enabled)=>{
    const rankedSocialProviders = $fea9e4b105970f8f$export$94af6b531db26586();
    for (const socialProvider of rankedSocialProviders){
        if (connected.includes(socialProvider) && enabled.includes(socialProvider)) return socialProvider;
    }
    return null;
};
const $fea9e4b105970f8f$export$e5abae2d758ca82f = (identities)=>{
    if (!identities) return [];
    return Object.values((0, $gtKO2.SocialProvider)).filter((provider)=>!!(identities === null || identities === void 0 ? void 0 : identities[provider]));
};
const $fea9e4b105970f8f$export$34b87b0d5d6ea34f = (location)=>{
    const enabledSocialButtons = [
        (0, $gtKO2.SocialProvider).Google
    ];
    if ((0, $ccxRw.isMicrosoftAuthEnabled)(location)) enabledSocialButtons.push((0, $gtKO2.SocialProvider).Microsoft);
    if ((0, $ccxRw.isAppleAuthEnabled)(location)) enabledSocialButtons.push((0, $gtKO2.SocialProvider).Apple);
    if ((0, $ccxRw.isSlackAuthEnabled)(location)) enabledSocialButtons.push((0, $gtKO2.SocialProvider).Slack);
    return enabledSocialButtons;
};
const $fea9e4b105970f8f$export$55a908504dbef32d = (socialProvider, application, hasPassword = true)=>Boolean(socialProvider && !hasPassword && application !== "trello");
const $fea9e4b105970f8f$export$e8b4b1bf168dca09 = (identities, location, application)=>{
    const connectedSocialProviders = $fea9e4b105970f8f$export$e5abae2d758ca82f(identities);
    const enabledSocialButtons = $fea9e4b105970f8f$export$34b87b0d5d6ea34f(location);
    const highlightedSocialProvider = $fea9e4b105970f8f$export$47bb6da133b3804e(connectedSocialProviders, enabledSocialButtons);
    const hasPassword = identities === null || identities === void 0 ? void 0 : identities.password;
    const isEligibleForSocialLoginOnly = $fea9e4b105970f8f$export$55a908504dbef32d(highlightedSocialProvider, application, hasPassword);
    return {
        isEligibleForSocialLoginOnly: isEligibleForSocialLoginOnly,
        highlightedSocialProvider: highlightedSocialProvider,
        connectedSocialProviders: connectedSocialProviders,
        enabledSocialButtons: enabledSocialButtons,
        firstProductAccessed: application || "unknown",
        hasPassword: hasPassword
    };
};

});



parcelRegister("7452z", function(module, exports) {

$parcel$export(module.exports, "MarketingConsentContextProvider", function () { return $92b9d05d69f85169$export$a01df84c5b0bda88; });
$parcel$export(module.exports, "useMarketingConsentContext", function () { return $92b9d05d69f85169$export$3bf9eae4cd157a8c; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");
const $92b9d05d69f85169$var$MarketingConsentContext = /*#__PURE__*/ (0, $91i6m.createContext)(null);
const $92b9d05d69f85169$export$a01df84c5b0bda88 = ({ children: children })=>{
    const [marketingConsent, setMarketingConsent] = (0, $91i6m.useState)(undefined);
    const value = (0, $91i6m.useMemo)(()=>({
            marketingConsent: marketingConsent,
            setMarketingConsent: setMarketingConsent
        }), [
        marketingConsent,
        setMarketingConsent
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)($92b9d05d69f85169$var$MarketingConsentContext.Provider, {
        value: value,
        children: children
    });
};
const $92b9d05d69f85169$export$3bf9eae4cd157a8c = ()=>{
    const context = (0, $91i6m.useContext)($92b9d05d69f85169$var$MarketingConsentContext);
    if (!context) throw new Error("useMarketingConsentContext must be used within MarketingConsentContextProvider");
    return context;
};

});

parcelRegister("2kfyN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $751e2a661bc986f3$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");
parcelRequire("h6aRF");
var $21dxG = parcelRequire("21dxG");

var $4Nxm2 = parcelRequire("4Nxm2");

var $6xwQE = parcelRequire("6xwQE");

var $h6Rwg = parcelRequire("h6Rwg");

var $NAfW5 = parcelRequire("NAfW5");

var $cZAbO = parcelRequire("cZAbO");

var $cs6gC = parcelRequire("cs6gC");

var $dBW46 = parcelRequire("dBW46");

var $6OnpU = parcelRequire("6OnpU");

const $751e2a661bc986f3$var$baseLoginPage = /*#__PURE__*/ (0, $91i6m.lazy)(()=>(parcelRequire("hmaSN")));
const $751e2a661bc986f3$var$requiredComponents = [
    (0, $4Nxm2.useLogin).name,
    (0, $6xwQE.useLoginSubmission).name,
    (0, $h6Rwg.useSocialLogin).name,
    (0, $NAfW5.useEmailFromSearchParams).name,
    (0, $cZAbO.LoginRecaptcha).name,
    (0, $cs6gC.LoginMarketingConsent).name,
    (0, $6OnpU.ResetPasswordLink).name
];
const $751e2a661bc986f3$var$OrchestratedLoginPage = ()=>{
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $21dxG.PageOrchestrator), {
        fallback: $751e2a661bc986f3$var$baseLoginPage,
        pages: (0, $dBW46.pages),
        requiredComponents: $751e2a661bc986f3$var$requiredComponents
    });
};
var $751e2a661bc986f3$export$2e2bcd8739ae039 = $751e2a661bc986f3$var$OrchestratedLoginPage;

});
parcelRegister("4Nxm2", function(module, exports) {

$parcel$export(module.exports, "useLogin", function () { return $ffa99c624ddf1c6c$export$d4e22f05f73ea56b; });

var $91i6m = parcelRequire("91i6m");

var $l2v8Y = parcelRequire("l2v8Y");

var $k8MAo = parcelRequire("k8MAo");

var $3yDip = parcelRequire("3yDip");

var $6VPdM = parcelRequire("6VPdM");

var $2aGBJ = parcelRequire("2aGBJ");

var $gtKO2 = parcelRequire("gtKO2");

var $1V2cH = parcelRequire("1V2cH");

var $4rBM8 = parcelRequire("4rBM8");

var $7eeh4 = parcelRequire("7eeh4");

var $4JAG5 = parcelRequire("4JAG5");

var $1UkGo = parcelRequire("1UkGo");

var $NAfW5 = parcelRequire("NAfW5");

var $cRW6P = parcelRequire("cRW6P");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $leG06 = parcelRequire("leG06");

var $5lN6k = parcelRequire("5lN6k");

var $6OnpU = parcelRequire("6OnpU");
const $ffa99c624ddf1c6c$export$d4e22f05f73ea56b = ({ autoRedirect: autoRedirect = true, autoCheckUsername: /**
   * By default, if the email/username of the user is considered restricted (e.g. by an admin of
   * their org), then `checkUsername` will be called automatically.
   *
   * Setting this option to `false` opts out of this behaviour.
   * */ autoCheckUsername = true } = {})=>{
    (0, $4PGUW.useRegisterComponent)($ffa99c624ddf1c6c$export$d4e22f05f73ea56b.name);
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const location = (0, $l2v8Y.useLocation)();
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const queryParams = (0, $91i6m.useMemo)(()=>Object.fromEntries(new URLSearchParams(location.search).entries()), [
        location.search
    ]);
    const isUsernameChecked = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isUsernameChecked;
    });
    const isCheckingUsername = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isCheckingUsername;
    });
    const isLoggingIn = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isLoggingIn;
    });
    const passwordless = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.passwordless;
    });
    const usernameExists = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.usernameExists;
    });
    const nextAttemptCount = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.nextAttempt;
    });
    const redirectUrl = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.redirectUrl;
    });
    const redirectType = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.redirectType;
    });
    const isMobileApp = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding.isMobileApp);
    const isAnyMobile = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding.isAnyMobile);
    const restrictedEmail = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.restrictedEmail;
    });
    const error = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.error;
    });
    const checkUsernameError = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login_fieldErrors, _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : (_state_login_fieldErrors = _state_login.fieldErrors) === null || _state_login_fieldErrors === void 0 ? void 0 : _state_login_fieldErrors.email;
    });
    const isRestrictedEmail = restrictedEmail || (queryParams === null || queryParams === void 0 ? void 0 : queryParams.restrict) === "true";
    const isLoading = isCheckingUsername || isLoggingIn;
    const { state: state } = (0, $4rBM8.useLoginState)();
    const { oidcContext: oidcContext, login: login } = state || {};
    const { error: errorFromInjectedState } = login || {};
    const navigate = (0, $l2v8Y.useNavigate)();
    const loginRecoveryOptions = (0, $NAfW5.useLoginRecoveryOptions)();
    const application = (0, $NAfW5.useCobrandingApplication)();
    // redirect
    (0, $91i6m.useEffect)(()=>{
        if (!autoRedirect) return;
        const shouldRedirect = !isMobileApp || (0, $7eeh4.isOidcDisplayMode)(oidcContext, (0, $gtKO2.OidcDisplay).LoginWithRedirect);
        if (redirectUrl) window.location.assign(redirectUrl);
        else if (!isLoading && isUsernameChecked && !usernameExists && shouldRedirect) {
            dispatch((0, $k8MAo.resetLoginForm)());
            analyticsClient.operationalEvent({
                page: (0, $1UkGo.pageId),
                subject: "loginAttempt",
                action: "redirectedToSignup"
            });
            if (location.search.length === 0) navigate("/signup?redirectedFrom=login");
            else navigate(`/signup${location.search}&redirectedFrom=login`);
        }
    }, [
        autoRedirect,
        analyticsClient,
        application,
        dispatch,
        navigate,
        isAnyMobile,
        isLoading,
        isMobileApp,
        isUsernameChecked,
        oidcContext,
        redirectUrl,
        usernameExists,
        location.search
    ]);
    const [isCheckUsernameCaptchaLoading, setIsCheckUsernameCaptchaLoading] = (0, $91i6m.useState)(false);
    const isCheckUsernameRecaptchaEnabled = (0, $4JAG5.isCheckUsernameRecaptchaEnabledFF)();
    const { errorCode: errorCode, infoCode: infoCode } = (0, $NAfW5.useSearchParamCodes)();
    // This 'combines' multiple error sources into one for easier consumption downstream.
    // 1. redux store (from server, either injected or fetched via separate api call to /frontend/state)
    // 2. fetched via api endpoint call to /login/state (which never gets written to the redux store)
    // 3. Any error code set externally via URL search param.
    //
    // Cases 1 and 2 are needed to reliably cover errors returned by server in both SAS and non-SAS contexts.
    const combinedError = (0, $91i6m.useMemo)(()=>error || errorFromInjectedState || errorCode, [
        error,
        errorFromInjectedState,
        errorCode
    ]);
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const resetPasswordLink = (0, $6OnpU.useResetPasswordLink)();
    const combinedErrorWithMessage = (0, $91i6m.useMemo)(()=>{
        if (!combinedError) return;
        const message = (0, $5lN6k.buildLoginErrorMessage)({
            error: combinedError,
            formatMessage: formatMessage,
            resetPasswordLink: resetPasswordLink,
            nextAttempt: nextAttemptCount,
            application: application
        });
        return {
            ...combinedError,
            message: message
        };
    }, [
        combinedError,
        formatMessage,
        resetPasswordLink,
        nextAttemptCount,
        application
    ]);
    const recaptchaType = (combinedError === null || combinedError === void 0 ? void 0 : combinedError.code) === "captchaScoreTooLow" ? "checkbox" : "score";
    const recaptcha = (0, $6VPdM.useRecaptcha)({
        pageId: $1UkGo.pageId,
        type: recaptchaType,
        enabledProp: isCheckUsernameRecaptchaEnabled,
        action: "checkUsername"
    });
    const dispatchCaptchaFailure = (0, $91i6m.useCallback)(()=>{
        dispatch((0, $k8MAo.checkUsernameCaptchaFailure)(navigator.onLine));
    }, [
        dispatch
    ]);
    const fetchRecaptchaToken = (0, $91i6m.useCallback)(async ()=>{
        try {
            setIsCheckUsernameCaptchaLoading(true);
            (0, $3yDip.recaptchaCheckUsernameFetchTokenInteraction).start();
            const challengeResponse = await recaptcha.fetchToken();
            (0, $3yDip.recaptchaCheckUsernameFetchTokenInteraction).stop({
                customData: {
                    restrict: isRestrictedEmail
                }
            });
            return challengeResponse;
        } catch (error) {
            analyticsClient.errorShownEvent((0, $1UkGo.pageId), "recaptchaError", {
                errorMessage: error.message
            });
            dispatchCaptchaFailure();
            return null;
        } finally{
            setIsCheckUsernameCaptchaLoading(false);
        }
    }, [
        analyticsClient,
        dispatchCaptchaFailure,
        isRestrictedEmail,
        recaptcha
    ]);
    const checkUsername = (0, $91i6m.useCallback)(async (username)=>{
        var _loginRecoveryOptions;
        let challengeResponse = null;
        if (isCheckUsernameRecaptchaEnabled && recaptcha.isLoaded) challengeResponse = await fetchRecaptchaToken();
        const query = {
            ...queryParams,
            email: username
        };
        delete query.errorCode;
        const searchParams = new URLSearchParams(query);
        navigate(`/login?${searchParams.toString()}${location.hash}`);
        analyticsClient.formSubmittedEvent((0, $1UkGo.pageId), "checkUsername", {
            recaptchaType: challengeResponse === null || challengeResponse === void 0 ? void 0 : challengeResponse.type
        });
        dispatch((0, $k8MAo.checkUsername)({
            analyticsClient: analyticsClient,
            username: username,
            params: location.search,
            recoveryToken: (_loginRecoveryOptions = loginRecoveryOptions(username)) === null || _loginRecoveryOptions === void 0 ? void 0 : _loginRecoveryOptions.recoveryToken,
            challengeResponse: challengeResponse
        }));
        dispatch((0, $cRW6P.fetchConsentConfig)(username));
    }, [
        isCheckUsernameRecaptchaEnabled,
        recaptcha.isLoaded,
        location.hash,
        location.search,
        analyticsClient,
        queryParams,
        navigate,
        dispatch,
        loginRecoveryOptions,
        fetchRecaptchaToken
    ]);
    const emailFromSearchParams = (0, $NAfW5.useEmailFromSearchParams)();
    // This code is intended to auto-submit the check-username request if email is restricted
    (0, $91i6m.useEffect)(()=>{
        const handleMount = async ()=>{
            if (!recaptcha.isLoaded) return;
            if (!autoCheckUsername) return;
            if (!isRestrictedEmail) return;
            const emailWithDefault = emailFromSearchParams || "";
            if (!emailWithDefault) return;
            // recaptchaType 'checkbox' should not be auto-submitted
            if (recaptchaType === "score") await checkUsername(emailWithDefault);
        };
        handleMount();
    // We only want this to run when the component mounts or
    // when recaptcha.isLoaded becomes true (if it was false)
    // We need to investigate why `useRecaptcha` always returns a new object,
    // So we can remove this eslint-disable rule and add all the correct dependencies.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        recaptcha.isLoaded,
        recaptchaType
    ]);
    const resetLogin = (0, $91i6m.useCallback)(()=>dispatch((0, $k8MAo.resetLoginForm)()), [
        dispatch
    ]);
    const isPasswordlessAllowed = passwordless !== (0, $gtKO2.CheckUserNamePasswordlessType).Disallowed && !(0, $7eeh4.isMobileOidc)(oidcContext);
    const isCheckUsernameLoading = isCheckingUsername || isCheckUsernameCaptchaLoading;
    return {
        isPasswordlessAllowed: /**
     * Indicates whether the user is eligible to log in via a link emailed to them.
     * */ isPasswordlessAllowed,
        isUsernameChecked: /**
     * Reflects the state of the first essential step of the login process.
     *
     * Will be false until `checkUsername` has been called. True thereafter (until reset via
     * a call to `resetLogin`).
     *
     * */ isUsernameChecked,
        isCheckUsernameLoading: /**
     * Reflects loading state following a call to `checkUsername`.
     * */ isCheckUsernameLoading,
        checkUsernameError: /**
     * Indicates the reason `checkUsername` has failed. See type definition for details.
     * */ checkUsernameError,
        isRestrictedEmail: /**
     * Indicates whether the user's username/email has been deemed restricted. In such cases,
     * `checkUsername` will be called automatically for this username, unless opted out by setting
     * the `autoCheckUsername` option to `false` in the args to `useLogin`.
     *
     * For example, the username may be restricted by admins in the user's org.
     * */ isRestrictedEmail,
        checkUsername: /**
     * This is the essential first step of the login process.
     *
     * NOTE: Until this handler has been called, username and password submission will not work.
     * */ checkUsername,
        /**
     * Indicates that login has failed for a particular reason. See type definition for details.
     * */ error: combinedErrorWithMessage,
        infoCode: /**
     * An externally set code indicating a message for the user may need to be rendered. See type
     * defintion for details.
     * */ infoCode,
        nextAttemptCount: /**
     * The number of times the user will have attempted to login (at their next attempt). After a
     * certain number of attempts, it may be desirable to render a message directing the user to try
     * to reset their password.
     *
     * (The base login experience does this when the count is greater than 4).
     * */ nextAttemptCount,
        redirectUrl: /**
     * The URL to which the user ought to be redirected, as indicated by the server. This
     * redirection will be automatic unless opted out in the args to `useLogin`.
     * */ redirectUrl,
        redirectType: /**
     * Indicates the reason given by the server for redirecting the user. Useful for rendering
     * relevant UI while the redirect is taking place (e.g. SSO).
     * */ redirectType,
        resetLogin: /**
     * Resets the state of the login process back to the first step (where `checkUsername` must be
     * called again).
     *
     * Should be called when user has chosen to enter a different username than the one they had
     * already entered.
     * */ resetLogin,
        recaptcha: recaptcha
    };
};

});
parcelRegister("3yDip", function(module, exports) {

$parcel$export(module.exports, "recaptchaCheckUsernameFetchTokenInteraction", function () { return $04c86f329a8264d4$export$b7874a5a14992cfe; });

var $iBu0H = parcelRequire("iBu0H");
const $04c86f329a8264d4$export$b7874a5a14992cfe = (0, $iBu0H.metrics).interaction({
    key: "aid-frontend-recaptcha-fetch-token-check-username"
});

});

parcelRegister("5lN6k", function(module, exports) {

$parcel$export(module.exports, "buildLoginErrorMessage", function () { return $190030bedfbf80d7$export$7a0831816210b6bb; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $bE8z6 = parcelRequire("bE8z6");
const $190030bedfbf80d7$export$7a0831816210b6bb = ({ error: error, formatMessage: formatMessage, resetPasswordLink: resetPasswordLink, nextAttempt: nextAttempt, application: application })=>{
    if (!error) return;
    const { args: args = {} } = error;
    switch(error === null || error === void 0 ? void 0 : error.code){
        case "captcha":
            return formatMessage({
                id: "login.error.captcha",
                defaultMessage: "We are having trouble verifying reCAPTCHA for this request. Please try again. If the problem persists, try another browser/device or reach out to Atlassian Support."
            });
        case "captchaScoreTooLow":
            return formatMessage({
                id: "login.error.captcha.score_too_low",
                defaultMessage: "We'd like to make sure it's really you. Please confirm you're not a robot.",
                description: "Message asking user to tick the reCAPTCHA checkbox and resubmit the form"
            });
        case "invalid_user_password":
            return $190030bedfbf80d7$var$incorrectCredentialsErrorMessage(formatMessage, nextAttempt, resetPasswordLink, application);
        case "ambiguous_user":
            return formatMessage({
                id: "login.error.details.ambiguous",
                defaultMessage: "It seems that you have multiple accounts associated with your email. Please contact your administrator to remove the duplicate."
            });
        case "no_email_on_remote_user":
            return formatMessage({
                id: "login.error.remote.user.no.email",
                defaultMessage: "Your {username} user doesn&#39;t have an associated email address, so we can&#39;t create your Atlassian account. Please contact support."
            }, {
                ...args
            });
        case "bitbucket_username_is_not_email":
            return formatMessage({
                id: "login.error.remote.user.using.username",
                defaultMessage: "You can no longer log in with a username. Use your primary email address {username} instead."
            }, {
                ...args
            });
        case "username_is_not_email":
            return formatMessage({
                id: "login.error.email.not.username",
                defaultMessage: "You must use your email address to log in. Did you mean to use {username}?"
            }, {
                ...args
            });
        case "bitbucket_email_is_not_primary":
            return formatMessage({
                id: "login.error.remote.user.using.alias",
                defaultMessage: "You can no longer log in with an email alias. Use your primary email address {username} instead."
            }, {
                ...args
            });
        case "bitbucket_mfa_enforced":
            return formatMessage({
                id: "login.error.user.mfa.enforced",
                defaultMessage: "Your organization wants you to secure your account by setting up two-step verification."
            }, {
                ...args
            });
        case "bitbucket_mfa_required":
            return formatMessage({
                id: "login.error.user.mfa.required",
                defaultMessage: "For added security, your organization wants you to log in with two-step verification."
            }, {
                ...args
            });
        case "bitbucket_saml_user":
            return formatMessage({
                id: "login.error.saml.user",
                defaultMessage: "For added security, your organization wants you to log in with single sign-on."
            }, {
                ...args
            });
        case "email_is_not_primary":
            return formatMessage({
                id: "login.error.email.not.username",
                defaultMessage: "You must use your email address to log in. Did you mean to use {username}?"
            }, {
                ...args
            });
        case "too_many_logins":
            return formatMessage({
                id: "login.error.too.many.logins",
                defaultMessage: "For security purposes, we&#39;ve temporarily locked your account due to multiple log in attempts within a short period of time. Please try again in a few minutes. If this issue persists, please contact Atlassian Support."
            });
        case "multiple_google_accounts":
            return formatMessage({
                id: "login.error.google.auth.contact.support",
                defaultMessage: "We&#39;ve encountered problems signing you in with your Google Account. Please contact support to resolve this problem."
            });
        case "unable_to_verify_google_token":
            return formatMessage({
                id: "login.error.unable.to.verify.google.token",
                defaultMessage: "We were unable to verify your Google Account. Please try again later."
            });
        case "google_email_change_not_allowed_by_auth_policy":
            return formatMessage({
                id: "login.error.google.email.change.not.allowed.by.auth.policy",
                defaultMessage: "Sorry, we detected an email change that is not supported by your organization's authentication policy. Please log in with an email address that matches your account."
            });
        case "google_email_change_not_allowed_by_user_managed_status":
            return formatMessage({
                id: "login.error.google.email.change.not.allowed.by.user.managed.status",
                defaultMessage: "We detected an email change that would remove you from your organization. Contact your organization admin to check your account is configured correctly or try to log in a different way."
            });
        case "social_login_missing_email":
            return formatMessage({
                id: "login.error.social.missing.email",
                defaultMessage: "We did not receive a valid email address from your identity provider. Please try logging in again by typing your email address. If you don't have a password, use the \"Can't log in\" link to set one."
            });
        case "social_login_missing_email_verified":
            return formatMessage({
                id: "login.error.social.missing.email.verified",
                defaultMessage: "We did not receive a valid email verification from your identity provider. Please try logging in again by typing your email address. If you don't have a password, use the \"Can't log in\" link to set one."
            });
        case "social_login_unexpected_login_type":
            return formatMessage({
                id: "login.error.social.unexpected.login.type",
                defaultMessage: "We did not receive valid information from your identity provider. Please try logging in again by typing your email address. If you don't have a password, use the \"Can't log in\" link to set one."
            });
        case "social_login_missing_slack_email_date_verified":
            return formatMessage({
                id: "login.error.slack.missing.email.date.verified",
                defaultMessage: "We did not receive a valid email date verified from your identity provider. Please try logging in again by typing your email address. If you don't have a password, use the \"Can't log in\" link to set one."
            });
        case "social_login_invalid_social_id":
            return formatMessage({
                id: "login.error.social.invalid.social.id",
                defaultMessage: "We did not receive valid id from your identity provider. Please try logging in again by typing your email address. If you don't have a password, use the \"Can't log in\" link to set one."
            });
        case "slack_login_invalid_team_id":
            return formatMessage({
                id: "login.error.slack.invalid.team.id",
                defaultMessage: "We did not receive valid team id from your identity provider. Please try logging in again by typing your email address. If you don't have a password, use the \"Can't log in\" link to set one."
            });
        case "social_login_managed_user":
            return formatMessage({
                id: "login.error.social.managed.user",
                defaultMessage: "Hmm... we're having trouble logging you in. Please try again with a different authentication method."
            });
        case "social_login_requires_password_change":
            return formatMessage({
                id: "login.error.social.requires.password.change",
                defaultMessage: "Your current password has expired, so you need to reset your password to continue."
            });
        case "social_login_hide_email_change_not_allowed_to_bypass_policy":
            return formatMessage({
                id: "login.error.social.hide.email.change.not.allowed.to.bypass.policy",
                defaultMessage: "Sorry, you cannot hide your email once you are part of an organization. Please ensure that you share your real email."
            });
        case "social_login_email_change_not_allowed_to_bypass_policy":
            return formatMessage({
                id: "login.error.social.email.change.not.allowed.to.bypass.policy",
                defaultMessage: "Sorry, we detected an email change that is not supported by your organization's authentication policy. Please log in with a email address that matches your account."
            });
        case "social_login_email_change_not_allowed":
            return formatMessage({
                id: "login.error.social.email.change.not.allowed",
                defaultMessage: "We detected an email change that would remove you from your organization. Contact your organization admin to check your account is configured correctly or try to log in a different way."
            });
        case "social_login_consent_required":
            return formatMessage({
                id: "login.error.social.login.consent.required",
                defaultMessage: "Please grant access to your account details if you wish to login to your Atlassian account."
            });
        case "user_is_blocked":
            return formatMessage({
                id: "login.error.user.blocked",
                defaultMessage: "This account has been deactivated. Please contact your organization admin."
            });
        case "social_login_banned":
            return formatMessage({
                id: "login.error.social.login.banned",
                defaultMessage: "Your admin has blocked third-party login. Log in with your email address instead."
            });
        case "apple_login_disabled":
            return formatMessage({
                id: "login.error.apple.login.disabled",
                defaultMessage: "Sorry, it is not possible to log in with Apple at this time. We are working on it."
            });
        case "microsoft_login_disabled":
            return formatMessage({
                id: "login.error.microsoft.login.disabled",
                defaultMessage: "Sorry, it is not possible to log in with Microsoft at this time. We are working on it."
            });
        case "slack_login_disabled":
            return formatMessage({
                id: "login.error.slack.login.disabled",
                defaultMessage: "Sorry, it is not possible to log in with Slack at this time. We are working on it."
            });
        case "password_leaked":
            return formatMessage({
                id: "login.error.password.leaked.xml",
                defaultMessage: "You must <reset-password-link>change your password</reset-password-link> to log in. Your current password has appeared in an external data breach and your Atlassian account is at risk. <password-leaked-link>Learn more</password-leaked-link>"
            }, {
                "reset-password-link": (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("a", {
                        href: resetPasswordLink,
                        children: chunks
                    }),
                "password-leaked-link": (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("a", {
                        href: (0, $bE8z6.PASSWORD_LEAKED_LINK),
                        children: chunks
                    })
            });
        case "login.form.token.expired":
            return formatMessage({
                id: "login.error.token.expired",
                defaultMessage: "Your login request has expired."
            });
        case "login.form.problem.encountered":
            return formatMessage({
                id: "login.error.problem.encountered",
                defaultMessage: "We&#39;ve encountered a problem. Please try again in a few minutes."
            });
        case "login.form.email.does.not.match.loggedin.user":
            return formatMessage({
                id: "login.form.email.does.not.match.loggedin.user",
                defaultMessage: "You're currently logged in as {username}, logging in as another user will log you out of your current session."
            }, {
                ...args
            });
        case "hosted_domain_mismatch":
            return formatMessage({
                id: "google.hosted.domain.mismatch",
                defaultMessage: "Unable to log in with Google. Contact your admin to check your account is configured correctly or try to log in a different way."
            });
        case "switch.session.expired":
            return formatMessage({
                id: "session.switch.error.expired",
                defaultMessage: "Your account session expired. Log in again to continue."
            });
        case "request_error":
            return formatMessage({
                id: "network.request.error",
                defaultMessage: "Unable to connect. Check your internet connection or the network settings for your browser and try again."
            });
        case "invalid.session.token":
            return formatMessage({
                id: "invalid.session.token",
                defaultMessage: "Your session token is invalid. Log in again to continue."
            });
        case "verify.email.expired":
            return formatMessage({
                id: "verify.email.expired",
                defaultMessage: "Your email verification attempt has expired. Enter your email address and try again."
            });
        case "verify.email.error":
            return formatMessage({
                id: "verify.email.error",
                defaultMessage: "Something went wrong while verifying your email address. Enter your email address and try again."
            });
        case "too_many_username_requests":
            return formatMessage({
                id: "check.username.rate.limit.exceeded",
                defaultMessage: "Too many login attempts detected. Please wait for a few minutes before trying again."
            });
        case "generic-consent-error":
            return formatMessage({
                id: "generic-consent-error",
                defaultMessage: "To access this page, you must accept the Privacy Notice."
            });
        case "consent-validation-error":
            return formatMessage({
                id: "consent-validation-error",
                defaultMessage: "Something went wrong while attempting to validate your consent. Try logging in again later."
            });
        case "consent-loading-error":
            return formatMessage({
                id: "consent-loading-error",
                defaultMessage: "Something went wrong while loading the consent screen. Try logging in again later."
            });
        default:
            return formatMessage({
                id: "login.error.unknown",
                defaultMessage: "Something went wrong while attempting to validate your credentials."
            });
    }
};
const $190030bedfbf80d7$var$incorrectCredentialsErrorMessage = (formatMessage, nextAttempt, resetPasswordLink, application)=>{
    if (nextAttempt > 4) return formatMessage({
        id: "login.error.invalid.credentials.more.help.xml",
        defaultMessage: "We've recently made changes to the login page. If you are having difficulty logging in, <reset-password-link>reset your password</reset-password-link>."
    }, {
        "reset-password-link": (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("a", {
                href: resetPasswordLink,
                children: chunks
            })
    });
    else if (application === "trello") return formatMessage({
        id: "login.error.invalid.credentials.trello.specific.help.xml",
        defaultMessage: "Incorrect email address and / or password. If you recently migrated your Trello account to an Atlassian account, you will need to use your Atlassian account password. Alternatively, you can get help <reset-password-link>logging in</reset-password-link>."
    }, {
        "reset-password-link": (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("a", {
                href: resetPasswordLink,
                children: chunks
            })
    });
    else return formatMessage({
        id: "login.error.invalid.credentials.xml",
        defaultMessage: "Incorrect email address and / or password.{br}Do you need help <reset-password-link>logging in</reset-password-link>?"
    }, {
        br: /*#__PURE__*/ (0, $4ZSso.jsx)("br", {}),
        "reset-password-link": (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)("a", {
                href: resetPasswordLink,
                children: chunks
            })
    });
};

});

parcelRegister("6OnpU", function(module, exports) {

$parcel$export(module.exports, "useResetPasswordLink", function () { return $8c2a1933c0efed9f$export$5976158e5c6687af; });
$parcel$export(module.exports, "ResetPasswordLink", function () { return $8c2a1933c0efed9f$export$67fc22a75e0cc5ca; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6d87w = parcelRequire("6d87w");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");
const $8c2a1933c0efed9f$export$5976158e5c6687af = ()=>{
    const location = (0, $6d87w.useLocation)();
    const link = (0, $91i6m.useMemo)(()=>"/login/resetpassword" + location.search, [
        location.search
    ]);
    return link;
};
const $8c2a1933c0efed9f$export$67fc22a75e0cc5ca = ({ children: children })=>{
    (0, $4PGUW.useRegisterComponent)($8c2a1933c0efed9f$export$67fc22a75e0cc5ca.name);
    const resetPasswordLink = $8c2a1933c0efed9f$export$5976158e5c6687af();
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6d87w.Link), {
        to: resetPasswordLink,
        id: "resetPassword",
        children: children
    });
};

});


parcelRegister("6xwQE", function(module, exports) {

$parcel$export(module.exports, "useLoginSubmission", function () { return $80aa55fa73b5fa35$export$b40fe35861b4a878; });

var $91i6m = parcelRequire("91i6m");

var $5lFna = parcelRequire("5lFna");

var $2aGBJ = parcelRequire("2aGBJ");

var $1V2cH = parcelRequire("1V2cH");

var $1UkGo = parcelRequire("1UkGo");

var $6eNI5 = parcelRequire("6eNI5");

var $k8MAo = parcelRequire("k8MAo");

var $21Xgy = parcelRequire("21Xgy");

var $9b70D = parcelRequire("9b70D");

var $NAfW5 = parcelRequire("NAfW5");

var $7452z = parcelRequire("7452z");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");
const $80aa55fa73b5fa35$export$b40fe35861b4a878 = ({ onFailure: onFailure } = {})=>{
    (0, $4PGUW.useRegisterComponent)($80aa55fa73b5fa35$export$b40fe35861b4a878.name);
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const anonymousId = (0, $1V2cH.useAnalyticsAnonymousId)();
    const isUsernameChecked = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isUsernameChecked;
    });
    const isCheckingUsername = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isCheckingUsername;
    });
    const isLoggingIn = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isLoggingIn;
    });
    const isLoading = isCheckingUsername || isLoggingIn;
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const appendReasonViewingScreen = (0, $NAfW5.useAppendReasonViewingScreen)();
    const { captchaValue: captchaValue } = (0, $6eNI5.useLoginTooManyAttemptsRecaptchaContext)();
    const { marketingConsent: marketingConsent } = (0, $7452z.useMarketingConsentContext)();
    const handleLogIn = (0, $91i6m.useCallback)((username, password)=>{
        if (!marketingConsent) {
            console.error("Form cannot be submitted without showing Marketing Consent");
            onFailure === null || onFailure === void 0 ? void 0 : onFailure();
            return;
        }
        if (!isUsernameChecked) {
            console.error("Cannot submit a username & password login attempt until check-username endpoint has been called");
            onFailure === null || onFailure === void 0 ? void 0 : onFailure();
            return;
        }
        analyticsClient.formSubmittedEvent((0, $1UkGo.pageId), "loginForm", appendReasonViewingScreen({
            marketingConsent: (0, $5lFna.dangerouslyCreateSafeString)(marketingConsent.state)
        }));
        const onLoginError = (code)=>{
            onFailure === null || onFailure === void 0 ? void 0 : onFailure();
            analyticsClient.trackingEvent({
                page: (0, $1UkGo.pageId),
                action: "submitted",
                subject: "credentials",
                attributes: {
                    successfulAuthentication: false,
                    errorCode: code
                }
            });
        };
        dispatch((0, $k8MAo.loginUsernamePassword)({
            username: username,
            password: password,
            captchaValue: captchaValue,
            location: window.location,
            onLoginError: onLoginError,
            marketingConsent: marketingConsent,
            anonymousId: anonymousId
        }));
    }, [
        analyticsClient,
        anonymousId,
        appendReasonViewingScreen,
        captchaValue,
        dispatch,
        isUsernameChecked,
        marketingConsent,
        onFailure
    ]);
    const handlePasswordlessLogIn = (0, $91i6m.useCallback)(async (email)=>{
        const { success: success } = await dispatch((0, $k8MAo.loginPasswordless)({
            email: email,
            captchaValue: captchaValue,
            location: window.location
        }));
        if (success) dispatch((0, $21Xgy.addFlag)("success", (0, $9b70D.LoginPageMessages).passwordlessSuccessTitle, (0, $9b70D.LoginPageMessages).passwordlessSuccessDescription));
    }, [
        dispatch,
        captchaValue
    ]);
    return {
        isLoading: /**
     * Indicates whether username & password submission is in progress.
     * */ isLoading,
        /**
     * Errors around the username (email) and password fields.
     * */ onPasswordlessLogin: handlePasswordlessLogIn,
        /**
     * Handle login with username and password.
     *
     * Note: this will be a no-op if the username (email) has not been checked by calling
     * `checkUsername` before calling `onLogin`.
     *
     * For accessing the state and handlers around working with `checkUsername`, see:
     * {@link file://./useLogin.ts}.
     * */ onLogin: handleLogIn
    };
};

});
parcelRegister("9b70D", function(module, exports) {

$parcel$export(module.exports, "LoginPageMessages", function () { return $9485df2f6920f372$export$81a860015c7169ad; });

var $j5RJC = parcelRequire("j5RJC");
const $9485df2f6920f372$export$81a860015c7169ad = (0, $j5RJC.defineMessages)({
    headTitle: {
        id: "login.head.title",
        defaultMessage: "Log in to continue"
    },
    contextualTitle: {
        id: "login.contextual.title",
        defaultMessage: "Continue to",
        description: `Precedes a page title or issue number. For example, "Continue to Sarah's Blogpost" or "Continue to TED-1024"`
    },
    socialAuthOr: {
        id: "social.auth.or",
        defaultMessage: "or"
    },
    socialAuthOrContinueWith: {
        id: "social.auth.or-continue-with",
        defaultMessage: "Or continue with:"
    },
    createAnAccount: {
        id: "login.create.an.account",
        defaultMessage: "Create an account"
    },
    passwordlessSuccessTitle: {
        id: "login.passwordless.success.title",
        defaultMessage: "Email sent"
    },
    passwordlessSuccessDescription: {
        id: "login.passwordless.success.description",
        defaultMessage: "We've sent you an email to log in."
    },
    socialFormHeader: {
        id: "login.social.form.header",
        defaultMessage: "Log in",
        description: "Subtle header shown on the social login form which allows users to login with the chosen social provider"
    },
    socialFormTitle: {
        id: "login.social.form.title",
        defaultMessage: "You logged in with your {socialProviderName} account before",
        description: "Title shown on the social login form which allows users to login with the chosen social provider"
    },
    socialFormUseDifferentLoginMethod: {
        id: "login.social.form.use-different-login-method",
        defaultMessage: "Use a different login method",
        description: "Button label shown on the social login form which allows users to login using another method. Takes the user back to the original login form."
    },
    continueAs: {
        id: "continue.as.title.as",
        defaultMessage: "Continue as",
        description: "This is a page title that will be followed by an avatar hero with name and email"
    }
});

});


parcelRegister("cZAbO", function(module, exports) {

$parcel$export(module.exports, "LoginRecaptcha", function () { return $a4d29ea41ec40977$export$1e978f900466132e; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $2aGBJ = parcelRequire("2aGBJ");

var $4JAG5 = parcelRequire("4JAG5");

var $lPSLn = parcelRequire("lPSLn");

var $g6OTd = parcelRequire("g6OTd");

var $6eNI5 = parcelRequire("6eNI5");

var $0wXBc = parcelRequire("0wXBc");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");
const $a4d29ea41ec40977$export$1e978f900466132e = ({ recaptchaEnabled: recaptchaEnabled, recaptchaComponent: recaptchaComponent })=>{
    (0, $4PGUW.useRegisterComponent)($a4d29ea41ec40977$export$1e978f900466132e.name);
    const isSecondStep = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isUsernameChecked;
    });
    const isCaptchaRequired = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isCaptchaRequired;
    });
    const isCheckUsernameRecaptchaEnabled = (0, $4JAG5.isCheckUsernameRecaptchaEnabledFF)();
    const shouldRenderCheckUsernameRecaptcha = isCheckUsernameRecaptchaEnabled && !isSecondStep && recaptchaEnabled && recaptchaComponent;
    const { setCaptchaValue: setCaptchaValue } = (0, $6eNI5.useLoginTooManyAttemptsRecaptchaContext)();
    const shouldRenderTooManyAttemptsRecaptcha = isSecondStep && isCaptchaRequired;
    const prevIsCaptchaRequired = (0, $0wXBc.usePrevious)(isCaptchaRequired);
    (0, $91i6m.useEffect)(()=>{
        if (prevIsCaptchaRequired && !isCaptchaRequired) setCaptchaValue(null);
    }, [
        isCaptchaRequired,
        prevIsCaptchaRequired,
        setCaptchaValue
    ]);
    const isCaptchaEnabledByConfig = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_appConfig;
        return (_state_appConfig = state.appConfig) === null || _state_appConfig === void 0 ? void 0 : _state_appConfig.recaptchaEnable;
    });
    const recaptchaEnterpriseCheckboxKeySite = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_appConfig;
        return (_state_appConfig = state.appConfig) === null || _state_appConfig === void 0 ? void 0 : _state_appConfig.recaptchaEnterpriseCheckboxKeySite;
    });
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4ZSso.Fragment), {
        children: isCaptchaEnabledByConfig && (shouldRenderCheckUsernameRecaptcha ? /*#__PURE__*/ (0, $4ZSso.jsx)((0, $g6OTd.default), {
            children: recaptchaComponent
        }) : shouldRenderTooManyAttemptsRecaptcha && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $g6OTd.default), {
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lPSLn.default), {
                sitekey: recaptchaEnterpriseCheckboxKeySite,
                onChange: setCaptchaValue
            })
        }))
    });
};

});
parcelRegister("lPSLn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc84cd0c6943b5c6$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $8hJHo = parcelRequire("8hJHo");

var $49Pnv = parcelRequire("49Pnv");
const $bc84cd0c6943b5c6$export$c8e68dd3bf26af81 = /*#__PURE__*/ (0, $91i6m.forwardRef)(function ReCAPTCHAEnterprise(props, ref) {
    const { grecaptcha: grecaptcha, onChange: onChange, onErrored: onErrored, onExpired: onExpired, size: size, sitekey: sitekey, action: action } = props;
    const enterprise = grecaptcha === null || grecaptcha === void 0 ? void 0 : grecaptcha.enterprise;
    const [widgetId, setWidgetId] = (0, $91i6m.useState)();
    const containerRef = (0, $91i6m.useRef)(null);
    const hasRendered = (0, $91i6m.useRef)(false);
    /**
     * The execution callbacks and states (hasRequest, resetRequired) etc.
     * are being tracked in a useRef since we don't want to react to its changes
     * but need to track it in-between renders.
     */ const executionRef = (0, $91i6m.useRef)({
        hasRequested: false,
        resetRequired: false
    });
    const resetExecutionHandlers = (0, $91i6m.useCallback)(()=>{
        delete executionRef.current.onResolve;
        delete executionRef.current.onReject;
    }, []);
    const reset = (0, $91i6m.useCallback)(()=>{
        if (enterprise && typeof widgetId === "number") enterprise.reset(widgetId);
    }, [
        enterprise,
        widgetId
    ]);
    const handleError = (0, $91i6m.useCallback)(()=>{
        var _executionRef_current;
        if (onErrored) onErrored();
        if ((_executionRef_current = executionRef.current) === null || _executionRef_current === void 0 ? void 0 : _executionRef_current.onReject) {
            executionRef.current.onReject();
            resetExecutionHandlers();
        }
    }, [
        onErrored,
        resetExecutionHandlers
    ]);
    const handleChange = (0, $91i6m.useCallback)((token)=>{
        var _executionRef_current;
        if (onChange) onChange(token);
        if (!token) handleError();
        else if ((_executionRef_current = executionRef.current) === null || _executionRef_current === void 0 ? void 0 : _executionRef_current.onResolve) {
            executionRef.current.onResolve(token);
            resetExecutionHandlers();
        }
    }, [
        handleError,
        onChange,
        resetExecutionHandlers
    ]);
    const handleExpired = (0, $91i6m.useCallback)(()=>{
        if (onExpired) {
            var _executionRef_current;
            onExpired();
            if ((_executionRef_current = executionRef.current) === null || _executionRef_current === void 0 ? void 0 : _executionRef_current.onReject) {
                executionRef.current.onReject();
                resetExecutionHandlers();
            }
        } else handleChange(null);
    }, [
        handleChange,
        onExpired,
        resetExecutionHandlers
    ]);
    const execute = (0, $91i6m.useCallback)((targetWidgetId)=>{
        const id = typeof targetWidgetId === "undefined" ? widgetId : targetWidgetId;
        if (enterprise && id !== undefined) {
            var _executionRef_current;
            // Tokens are cached, reset is needed after first execute
            if ((_executionRef_current = executionRef.current) === null || _executionRef_current === void 0 ? void 0 : _executionRef_current.resetRequired) reset();
            executionRef.current.resetRequired = true;
            enterprise.execute(id);
        } else executionRef.current.hasRequested = true;
    }, [
        enterprise,
        reset,
        widgetId
    ]);
    const renderExplicit = (0, $91i6m.useCallback)(()=>{
        var _executionRef_current;
        if (!sitekey) {
            (0, $49Pnv.captureErrorMessage)("ReCAPTCHAEnterprise: recaptcha enterprise site key not provided");
            return;
        }
        // Check if grecaptcha is available and if it hasn't been rendered already
        if (!(enterprise === null || enterprise === void 0 ? void 0 : enterprise.render) || widgetId !== undefined || hasRendered.current) return;
        const wrapper = document.createElement("div");
        const id = enterprise.render(wrapper, {
            sitekey: sitekey,
            action: action,
            size: size,
            callback: handleChange,
            "expired-callback": handleExpired,
            "error-callback": handleError
        });
        setWidgetId(id);
        containerRef.current.appendChild(wrapper);
        if ((_executionRef_current = executionRef.current) === null || _executionRef_current === void 0 ? void 0 : _executionRef_current.hasRequested) {
            executionRef.current.hasRequested = false;
            execute(id);
        }
        hasRendered.current = true;
    }, [
        action,
        enterprise,
        execute,
        handleChange,
        handleError,
        handleExpired,
        sitekey,
        size,
        widgetId
    ]);
    (0, $91i6m.useEffect)(()=>{
        /**
       * This has to run on every render, hence why there is no dependency array.
       * renderExplicit was called on componentDidMount & componentDidUpdate when it was a class component.
       */ renderExplicit();
    });
    (0, $91i6m.useEffect)(()=>{
        const delayOfCaptchaIframeRemoving = ()=>{
            var _containerRef_current;
            const temporaryNode = document.createElement("div");
            document.body.appendChild(temporaryNode);
            temporaryNode.style.display = "none";
            // move of the recaptcha to a temporary node
            while((_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.firstChild)temporaryNode.appendChild(containerRef.current.firstChild);
            // delete the temporary node after reset will be done
            setTimeout(()=>document.body.removeChild(temporaryNode), 5000);
        };
        return ()=>{
            if (widgetId !== undefined) {
                delayOfCaptchaIframeRemoving();
                reset();
                hasRendered.current = false;
            }
        };
    }, [
        reset,
        widgetId
    ]);
    (0, $91i6m.useImperativeHandle)(ref, ()=>({
            executeAsync () {
                return new Promise((resolve, reject)=>{
                    executionRef.current.onResolve = resolve;
                    executionRef.current.onReject = reject;
                    execute();
                });
            }
        }), [
        execute
    ]);
    return /*#__PURE__*/ (0, $4ZSso.jsx)("div", {
        "data-testid": "ReCAPTCHAEnterprise",
        ref: containerRef
    });
});
var $bc84cd0c6943b5c6$export$2e2bcd8739ae039 = (0, $8hJHo.default)(()=>"https://www.recaptcha.net/recaptcha/enterprise.js?onload=onloadcallback&render=explicit", {
    callbackName: "onloadcallback",
    globalName: "grecaptcha"
})($bc84cd0c6943b5c6$export$c8e68dd3bf26af81);

});

parcelRegister("g6OTd", function(module, exports) {

$parcel$export(module.exports, "RecaptchaNotice", function () { return $6101c3d22ae535b7$export$4faf58f44fb24e61; });
$parcel$export(module.exports, "default", function () { return $6101c3d22ae535b7$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $fqDmW = parcelRequire("fqDmW");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");

var $6T9dz = parcelRequire("6T9dz");
parcelRequire("91i6m");

var $k8ZoM = parcelRequire("k8ZoM");
let $6101c3d22ae535b7$var$_ = (t)=>t, $6101c3d22ae535b7$var$t, $6101c3d22ae535b7$var$t1;
const $6101c3d22ae535b7$var$ReCaptchaContainer = (0, $fqDmW.default).div($6101c3d22ae535b7$var$t || ($6101c3d22ae535b7$var$t = $6101c3d22ae535b7$var$_`
  margin-top: ${0}px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`), (0, $6e88g.gridSize)());
const $6101c3d22ae535b7$var$PolicyLink = (0, $fqDmW.default).a($6101c3d22ae535b7$var$t1 || ($6101c3d22ae535b7$var$t1 = $6101c3d22ae535b7$var$_`
  color: ${0};

  &:hover {
    color: ${0};
  }
`), (0, $k8ZoM.default)("color.link", (0, $kLNLK).B400), (0, $k8ZoM.default)("color.link", (0, $kLNLK).B400));
const $6101c3d22ae535b7$export$4faf58f44fb24e61 = ()=>/*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
        id: "signup.form.recaptcha.notice.xml",
        defaultMessage: "This site is protected by reCAPTCHA and the Google <google-pp-link>Privacy Policy</google-pp-link> and <google-tos-link>Terms of Service</google-tos-link> apply.",
        values: {
            "google-pp-link": (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)($6101c3d22ae535b7$var$PolicyLink, {
                    href: "https://policies.google.com/privacy",
                    target: "_blank",
                    rel: "noreferrer noopener",
                    children: chunks
                }),
            "google-tos-link": (chunks)=>/*#__PURE__*/ (0, $4ZSso.jsx)($6101c3d22ae535b7$var$PolicyLink, {
                    href: "https://policies.google.com/terms",
                    target: "_blank",
                    rel: "noreferrer noopener",
                    children: chunks
                })
        }
    });
var $6101c3d22ae535b7$export$2e2bcd8739ae039 = $6101c3d22ae535b7$var$ReCaptchaContainer;

});


parcelRegister("cs6gC", function(module, exports) {

$parcel$export(module.exports, "LoginMarketingConsent", function () { return $de2ebe89c2fc5034$export$7f3ec3ad6a2266d2; });

var $4ZSso = parcelRequire("4ZSso");
parcelRequire("91i6m");

var $2aGBJ = parcelRequire("2aGBJ");
parcelRequire("h6aRF");
var $4PGUW = parcelRequire("4PGUW");

var $7452z = parcelRequire("7452z");

var $1TbRW = parcelRequire("1TbRW");
const $de2ebe89c2fc5034$export$7f3ec3ad6a2266d2 = ()=>{
    (0, $4PGUW.useRegisterComponent)($de2ebe89c2fc5034$export$7f3ec3ad6a2266d2.name);
    const config = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_marketingConsent;
        return (_state_marketingConsent = state.marketingConsent) === null || _state_marketingConsent === void 0 ? void 0 : _state_marketingConsent.config;
    });
    const isUsernameChecked = (0, $2aGBJ.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isUsernameChecked;
    });
    const { setMarketingConsent: setMarketingConsent } = (0, $7452z.useMarketingConsentContext)();
    if (!isUsernameChecked) return null;
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $1TbRW.StyledMarketingConsent), {
        config: config,
        onConsentChange: setMarketingConsent
    });
};

});
parcelRegister("1TbRW", function(module, exports) {

$parcel$export(module.exports, "RecaptchaNoticeContainer", function () { return $87e74b996a0bd675$export$e55f3ed22cb4599; });
$parcel$export(module.exports, "StyledMarketingConsent", function () { return $87e74b996a0bd675$export$79bf8aceefa9b5d6; });

var $fqDmW = parcelRequire("fqDmW");

var $6e88g = parcelRequire("6e88g");

var $fxz8k = parcelRequire("fxz8k");
let $87e74b996a0bd675$var$_ = (t)=>t, $87e74b996a0bd675$var$t, $87e74b996a0bd675$var$t1;
const $87e74b996a0bd675$export$e55f3ed22cb4599 = (0, $fqDmW.default).div($87e74b996a0bd675$var$t || ($87e74b996a0bd675$var$t = $87e74b996a0bd675$var$_`
  margin-top: ${0}px;
`), (0, $6e88g.gridSize)());
const $87e74b996a0bd675$export$79bf8aceefa9b5d6 = (0, $fqDmW.default)((0, $fxz8k.default))($87e74b996a0bd675$var$t1 || ($87e74b996a0bd675$var$t1 = $87e74b996a0bd675$var$_`
  padding-top: ${0}px;
`), (0, $6e88g.gridSize)() * 2);

});


parcelRegister("dBW46", function(module, exports) {

$parcel$export(module.exports, "pages", function () { return $301af16466d55e42$export$da3bc2f57520e3c3; });

var $91i6m = parcelRequire("91i6m");

var $6IwzG = parcelRequire("6IwzG");

const $301af16466d55e42$export$da3bc2f57520e3c3 = [
    {
        application: "pollinator",
        cobranding: (0, $6IwzG.AdvancedCobranding).DEMO,
        Component: (0, $91i6m.lazy)(()=>(parcelRequire("jsiii"))),
        owner: "iignatov2@atlassian.com",
        slackChannel: "id-kirby",
        monitoringUrls: [
            // TODO: Kirby to add demo pollinator
            ""
        ]
    }
];

});
parcelRegister("jsiii", function(module, exports) {

var $2xbij = parcelRequire("2xbij");
module.exports = Promise.all([
    $2xbij("1uyH1"),
    $2xbij("lnTrZ"),
    $2xbij("cMYEL"),
    $2xbij("bWK1p")
]).then(()=>parcelRequire("62roJ"));

});


parcelRegister("hmaSN", function(module, exports) {

var $2xbij = parcelRequire("2xbij");
module.exports = Promise.all([
    $2xbij("1uyH1"),
    $2xbij("ayVsC"),
    $2xbij("daCag"),
    $2xbij("lnTrZ"),
    $2xbij("cMYEL"),
    $2xbij("01ogN")
]).then(()=>parcelRequire("b8EMT"));

});



parcelRegister("bb3nf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $823356c98a5580de$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $823356c98a5580de$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});


//# sourceMappingURL=page.bb5c60fd.js.map
